export default {
  enquiry: "发送咨询",
  touch: "感兴趣吗？联系我们",
  touch1: "",
  future: "把连接变简单   让世界更高效",
  follow: "关注我们",
  learnMore: "了解更多",
  LEARN: "了解更多",
  origin: "原文请参考:",
  mail1: "邮箱不能为空",
  mail2: "邮箱格式错误",
  success: "成功",
  fail: "失败",
  enquiryBox: {
    title: "联系我们",
    des: "我们乐于聆听来自于您的反馈或意见",
    left: {
      title1: "我们在此",
      title2: "发送邮件",
      title3: "或通过社交平台联系我们",
      text1: "解答您的咨询",
      text2: "分享行业洞见",
      text3: "分享应用案例",
      text4: "分享创新思路",
      text5: "客服邮箱",
      text6: "support@redteamobile.com",
      text7: "公司事务",
      text8: "communications@redteamobile.com",
    },
    right: {
      text1: "姓名",
      text2: "公司邮箱",
      text3: "公司名称",
      text4: "电话",
      text5: "详细描述您的疑问",
    },
    hear: "期待您的反馈",
  },
  iphoneBox: {
    title: "iPhone全球上网服务",
    title1: "立即下载RedteaGO，体验一个App全球上网。",
    text1: "一键激活，即刻连网。",
    text2: "网络流量空中下发，无需实体SIM卡。",
    text3: "套餐即买即用，告别天价漫游。",
    mtitle: "iPhone全球上网服务",
    mtitle1: "立即下载RedteaGO，体验一个App全球上网。",
    mtext1: "一键连网",
    mtext2: "无需SIM卡",
    mtext3: "即买即用",
    mtext4: "告别天价漫游",
    more: "了解更多",
    chOnly: "* 适用于双卡iPhone机型海外无锁版。",
  },
  coverage: {
    title: "国家及地区",
    title0: "网络资源覆盖",
    title1: "亚  洲",
    text1:
      "阿联酋、巴基斯坦、菲律宾、韩国、哈萨克斯坦、印度、印度尼西亚、吉尔吉斯斯坦、老挝、马来西亚、孟加拉国、尼泊尔、日本、沙特阿拉伯、斯里兰卡、泰国、乌兹别克斯坦、新加坡、以色列、中国香港、中国澳门、中国台湾",
    title2: "欧  洲",
    text2:
      "阿尔巴尼亚、爱尔兰、奥地利、阿塞拜疆、爱沙尼亚、白俄罗斯、保加利亚、比利时、冰岛、波兰、波斯尼亚、克罗地亚、丹麦、德国、法国、芬兰、格陵兰岛、格鲁吉亚、荷兰、黑塞哥维那、黑山、捷克共和国、拉脱维亚、列支敦士登、立陶宛、罗马尼亚、卢森堡、马耳他、马其顿、摩尔多瓦、挪威、葡萄牙、瑞典、瑞士、塞尔维亚、塞浦路斯、斯洛伐克、斯洛文尼亚、土耳其、西班牙、希腊、匈牙利、亚美尼亚、意大利、英国",
    title3: "北美洲",
    text3: "关岛、加拿大、美国、墨西哥、塞班",
    title4: "大洋洲",
    text4: "澳大利亚、新西兰",
    title5: "非  洲",
    text5: "埃及、加纳、南非",
    title6: "拉丁美洲",
    text6:
      "阿根廷、巴拿马、巴西、厄瓜多尔、哥伦比亚、哥斯达黎加、瓜地马拉、秘鲁、萨尔瓦多、乌拉圭、智利",
  },
  nav: {
    Home: "首页",
    CaaS: "连接即服务",
    RedteaGO: "RedteaGO",
    RedteaReady: "RedteaReady",
    eSimPlus: "eSIM.plus",
    AndroidWeb: "Android <br/>Built-in SIM",
    GlobalSIMWeb: "Global <br/>SIM Card",
    DPPlus: "SM-DP+",
    ES: "Entitlement Server",
    RedteaGOAPP: "Carrier APP",
    eSIM: "RedteaSIM",
    eSIMDes: "RedteaSIM",
    cost: "更低SIM生产成本",
    Improve: "更快SIM分发方式",
    exp: "更好用户使用体验",
    Resources: "信息中心",
    AboutUs: "关于我们",
    ContactUs: "联系我们",
    Global: "网络覆盖",
    Embedded: "终端集成",
    Open: "开放平台",
    OpenSca: "开放 & 可扩展",
    Smart: "智能连接",
    GlobalData: "国际漫游服务",
    Android: "安卓内置App",
    iPhone: "eSIM二维码",
    Pixel: "Pixel eSIM App",
    eSIMDataPlan: "eSIM Data Plan",
    GlobalSIM: "国际流量卡",
    M2M: "RedteaReady",
    Consumers: "RedteaGO",
    Turnkey: "M2M设备一站式连接方案",
    Fixed: "零售",
    Automotive: "汽车",
    Handheld: "行业终端",
    Logistcs: "物流追踪",
    Utilities: "公共事业 (NB)",
    Dongle: "​自有品牌",
    Leverage: "面向运营商的eSIM服务",
    NewsEvents: "新闻动态",
    IndustryReports: "行业报告",
    Insights: "博客观点",
    TermsJargons: "行业热词",
    FAQ: "常见问题",
    Overview: "公司概览",
    Mission: "使命",
    Vision: "愿景",
    Values: "价值观",
    Recognition: "行业认可",
    Careers: "职业机会",
    Team: "红茶人",
    iosEsim: "iPhone eSIM App",
    copyRight: "Copyright © 2018-2024 深圳杰睿联科技有限公司",
  },
  Home: {
    facts: {
      number1: "100+",
      text1: "国家或地区3G/4G网络覆盖",
      number2: "30+",
      text2: "运营商合作伙伴",
      number3: "2.5亿+",
      text3: "终端eSIM能力覆盖",
      number4: "1亿+",
      text4: "注册用户",
      number5: "30+",
      text5: "设备、模组及芯片厂商合作伙伴",
    },
    title: "赋能设备连接的未来",
    position:
      "红茶移动致力于发展eSIM核心技术在行业领域的实际应用。我们将复杂的底层通信功能打包成易用、灵活、可靠，且容易扩展的连接能力，为移动运营商、设备制造商、芯片及模组制造商提供创新的产品解决方案及业务合作模式，提高eSIM市场渗透率，应对万物互联时代「连接」 与 「 可扩展性」两大挑战，推动物联网大规模部署的应用实现。",
    connect: {
      title: "无所不在的连接与创新的SIM管理",
      title1: "插电即连接",
      text1:
        "让设备自带连接能力，免拔插SIM卡，连接Wi-Fi或以太网才可获取访问权限等一系列繁琐的步骤。",
      title2: "保持在线",
      text2:
        "帮助设备断网后迅速恢复连接，支持无网环境购买开通流量套餐，无网无卡环境下追踪设备等功能。",
      title3: "(e)SIM生命周期管理",
      text3:
        "通过简化网络资源管理和SIM卡分发流程，提供一站式无忧(e)SIM生命周期管理体验。",
      title4: "连接可扩展",
      text4:
        "通过CaaS（连接即服务），帮助客户应对IoT时代「连接」 和 「可扩展性」两大挑战。",
    },
    caas: {
      title: "连接即服务",
      des: "我们在为客户简化获取网络连接的流程上投入大量工作，旨在使「网络连接」成为一项基础服务 ——「连接即服务」。",
      title1: "虚拟化",
      text1:
        "基于eSIM技术的终端解决方案支持主流芯片，并可适配多种操作系统和安全介质。",
      title2: "抽象化",
      text2: "把与实现网络连接相关的具体问题抽象为简单省心的连接服务打包提供。",
      title3: "开放化",
      text3:
        "通过增强互操作性和提供开放接口，让蜂窝网络连接成为轻量、易用的基础服务。",
    },
    product: {
      title: "产品组成",
      des: "为消费者和M2M市场提供多样化的设备连接服务，包含：多国流量覆盖、远程 SIM 配置（RSP）平台、设备连接管理平台（CMP）、eSIM 终端集成方案，及智能连接服务等，为设备制造商构建易于规模化扩展的物联网连接能力。",
      title1: "RedteaGO",
      text1: "消费者国际漫游服务",
      title2: "RedteaReady",
      text2: "可扩展的M2M设备连接解决方案",
      title3: "RedteaSIM",
      text3: "基于低功耗广域物联网的新型SIM分发服务",
    },
    aboutTitle: "关于红茶移动",
    aboutDes:
      "作为一家CaaS公司，红茶移动把「把连接变简单   让世界更高效」作为企业使命，致力于基于泛在蜂窝网络覆盖，为多样化的智能设备提供整套搭载eSIM能力的设备连接解决方案。 「正直」和「果敢」是红茶移动业务开展的核心价值观，也是每一位红茶移动员工保持真我的个人价值观。",
    say: {
      title: "反馈及评价",
      content1:
        "红茶移动的 ‘ 红茶虚拟SIM(vSIM）’ 为一站式解决方案，其自有的订购管理平台能根据终端用户的需求远程发放eSIM, 并且已经在中国和韩国的手机设备上得以应用。",
      author1: "--lain Maxwell，SIM的未来，虚拟SIM的兴起作者",
      content2:
        "红茶移动与世界各地的运营商紧密合作，为中国出境游客提供端到端的蜂窝网络连接解决方案，让出境用户可以轻松访问本地网络，无需昂贵的漫游资费。",
      author2: "--GSMA",
      content3:
        "红茶移动联合GSMA在澳门共同举办了2017第五届WAS.此次活动提供了一个很好的平台，各大重要的移动运营商，决策者，以及更广泛的移动供应链各个企业在此齐聚一堂。",
      author3: "--Telekom-ICSS",
      content4:
        "我给我的红茶移动国际漫游卡又充了一天的钱。无论在土耳其，还是后来在慕尼黑，我的手机都能够确保联网，作为唯一一个对外联系点，报平安，上网查信息，联系各种人帮忙。我本来只是借转机体验这个国际上网卡产品的，没想到派上了大用场。",
      author4: "--尤晓彤，“36小时，从伊斯坦布尔到上海”",
      content5:
        "Qualcomm Technologies 5G愿景的一个重要方面，是在可信赖的SIM上采用领先的新型标准和创新技术，我们和红茶移动的合作示范了GSMA的远程SIM配置规范如何在高通骁龙移动平台上运行，并同时有效满足与现有移动运营商基础架构的无缝集成。",
      author5: "--Sy Choudhury, Qualcomm Technologies, InC. 产品管理高级总监",
      click: "点击查看原文",
    },
  },
  Cass: {
    medium: "安全介质",
    OS: "操作系统",
    Chip: "芯片",
    ico1: "全球覆盖",
    ico2: "嵌入式",
    ico3: "开放",
    ico4: "智能",
    intro:
      "红茶移动于2018年提出「CaaS，连接即服务」的概念，旨在使「连接」成为一项基础服务。我们负责包揽与复杂的网络基础架构打交道的繁琐工作，将网络连接打包成简单易用的基础服务和通用API对外开放，可以极大简化物联网设备和第三方开发者获取及管理蜂窝网络的流程。我们相信，继SaaS、PaaS和IaaS成为云计算的三大服务模型之后，CaaS将成为云计算在物联网时代的下一个服务模型。",
    tra: "传统方案：",
    tea: "我们的方案：",
    global: {
      title: "覆盖全球的网络资源",
      text1: "和每个地区的运营商协商签约，分别运营管理每个设备的蜂窝网络流量。",
      content1:
        "全球网络覆盖，本地网络资费，支持多种套餐资源订购。我们的3G/4G网络资源已覆盖超过100个国家和地区。",
      check: "查看全球网络资源覆盖详情",
    },
    em: {
      title: "多样化的终端解决方案",
      text1: "分别为每个设备安装一张SIM卡；",
      text2: "分别每个设备购置物联网模组；",
      text3:
        "如果想更换运营商网络，就需要更换SIM卡，因为一张SIM卡只能储存一家运营商的码号资源。",
      content1:
        "通过远程码号资源下发技术实现网络初始化连接和套餐订购，并提供备用网络帮助设备在断网后迅速恢复连接，eSIM终端集成支持主流芯片和多种操作系统，并可适配多种不同的存储介质。",
      content2: "SIM能力嵌入或集成进芯片或模组中，设备插电即可获取网络连接；",
      content3: "设备无需做硬件改造；",
      content4: "可根据设备实时位置动态选择可匹配的优质运营商网络。",
    },
    open: {
      title: "开放与可扩展",
      text1: "操心如何获取网络连接，如何运营管理流量套餐；",
      text2: "操心网络覆盖和设备意外断网。",
      content1:
        "「连接即服务」的解决方案具备让设备插电即可联网、网络有备份保障、连接可编程等特性，易于构建规模化扩展的物联网连接能力。",
      content2: "可通过开放接口轻松管理连接；",
      content3: "连接成为具备互操作性的基础服务。",
    },
    smart: {
      title: "智能化连接",
      des: "针对应用场景因地制宜地提供连接解决方案，比如我们根据使用场景需求，为客户提供的无网购买、特定app专属定向流量，以及通过远程强制联网帮助设备找回等特色功能。",
    },
  },
  RedteaGo: {
    title: "RedteaGO的eSIM能力及漫游服务已触达2.5亿手机终端",
    des: "怀揣「自由连接无国界的使命」，RedteaGO是红茶移动推出的面向消费者的国际数据漫游服务。智能手机用户通过RedteaGO内置服务可以根据终端设备所在位置动态获取当地网络流量资源，无需实体SIM卡，即可在全球100多个国家或地区的旅游和商务出行中享受灵活便捷的上网服务。",
    desShort: "RedteaGO是红茶移动推出的全球数据漫游服务。",
    content1: "灵活选择目的地旅行流量套餐。",
    content2: "直接通过手机app上网。",
    content3: "支持特定app专属流量套餐包。",
    content4: "支持流量套餐无网购买激活。",
    Highlights: {
      title: "产品优势",
      des: "提供运营商流量资源整合、云管理平台开发、用户界面定制、数据流量套餐运营等系列服务。",
      content1: "RSP平台遵循GSMA eSIM标准。",
      content2:
        "终端方案可适配eUICC，也可扩展到非eUICC (如：TEE, iUICC, eSE)设备。",
      content3: "支持高通、联发科及三星芯片。",
    },
    anTitle: "3. RedteaGO for Android：手机内置虚拟SIM为用户提供全球网络服务。",
    anDes:
      "我们自2015年推出的手机内置国际漫游服务至今已在众多安卓手机品牌上得以广泛商用，并通过一加、OPPO、vivo在海外推出的手机机型进入泰国、马来西亚、印度尼西亚、印度、菲律宾等其他亚洲国家市场，以及欧美市场。",
    iTitle: "3. RedteaGO eSIM 二维码: 扫码即用的eSIM流量集市。",
    iDes: "我们为带有eSIM功能的手机用户提供丰富的eSIM选择，用户只需扫描我们提供的二维码即可进行远程激活享用流量套餐，无需实体SIM卡，也无需操心哪家运营商支持eSIM功能。",
    pTitle:
      "2. RedteaGO for Pixel: 一款为谷歌推出的Pixel 3系列eSIM手机提供全球流量服务的app。",
    pDes: "RedteaGO for Pixel: 一款为谷歌推出的Pixel 3系列eSIM手机提供全球流量服务的app。用户通过在Google Play应用商店下载「RedteaGO」app即可自由选择全球多个国家和地区的流量套餐。该app支持谷歌Pixel 3系列的所有eSIM手机机型 (Pixel 3, 3XL,3a 及 3a XL) 。",
    sTitle: "4. RedteaGO SIM卡: 一张SIM卡游世界。",
    sDes: "虽然仍然以实体卡形式存在并且可以插拔，RedteaGO流量SIM卡通过覆盖多个国家的运营商网络资源和SIM远程配置(空中下发)技术，实现了一张卡连接全球网络，是发展eSIM过程中的过渡方案，用户可以重复使用。RedteaGO全球流量SIM卡目前仅提供经销业务模式。",
    sDes0: "如果有兴趣成为我们的合作伙伴，请发送咨询到",
    sDes1: "或访问",
    sDes2: "了解详情。",
    phoneTitle: "1. RedteaGO for iPhone：基于新iPhone系列的eSIM网络服务。",
    phonetxt1:
      "让iPhone用户实现了在全球多个国家和地区动态选择移动网络服务的自由，流量套餐可以即买即用，非常便利。海外无锁版双卡iPhone机型用户只需从苹果应用商店下载",
    phonetxt2: "RedteaGO应用",
    phonetxt3:
      "，并将系统升级至iOS 13.3或更高版本，即可在全球超过50个国家及地区自由享受灵活便捷、资费优廉的数据上网服务。该服务预计将在近期新增更多目的地国家覆盖。",
  },
  RedteaSIM: {
    title1: "5G时代的LPWAN集成式SIM解决方案",
    des1: "新型SIM分发管理方案RedteaSIM，将SIM直接集成于系统芯片 (SoC) 中，实现成本效益和分发效率的双重提升。",
    des2: "RedteaSIM是红茶移动面向运营商和设备商推出的一种创新的SIM分发管理方案，为低功耗广域物联网（包括NB和Cat-M1)  的蜂窝网络连接应用带来颠覆性的变革。通过与芯片厂商，模组厂商，设备厂商和运营商开展广泛合作，红茶移动推出的RedteaSIM方案，可实现将SIM功能直接集成在芯片上，空中下发，在设备生产过程中即预置运营商资源，从而降低集成复杂度。RedteaSIM旨在推动大规模物联网部署，进一步带来更经济、更高效分发、更简化的SIM周期管理过程等优势的连接方案。",
    title2: "更经济的SIM卡生产成本",
    title3: "更有效的SIM卡分发方式",
    title4: "更优化的用户使用体验",
    content1:
      "因为不再需要插拔式或贴片式SIM卡，以及卡托等实体硬件，直接降低SIM卡的生产和采购成本，并为设备节省空间。",
    content2:
      "可消除SIM卡分发管理、仓储、物流运输等成本，同时降低之后的分发成本。",
    content3:
      "可有效控制需要实地造访才能更换SIM卡所产生的成本，包括人工部署和设备召回的成本。",
    content4:
      "在设备出厂前将SIM功能集成到系统芯片 (SoC) 中，降低IoT设备获取蜂窝网络连接的难度。",
    content5:
      "通过SIM码号资源的无缝切换 (基于远程SIM配置技术实现)，简化网络资源管理和SIM分发流程。",
    content6:
      "可帮助设备减少功耗，这对于大部分低功耗广域物联网 (LPWA) 场景部署尤为重要。",
    content7: "无需对既有SM-DP+做改造投入，加速部署过程，简化整个SIM管理周期。",
    content8:
      "运营商和设备厂商基于web界面或app即可实现码号资源的初始化安装、SIM码号资源配置，以及流量套餐订购管理，无需实体SIM卡。",
    content9: "可有效避免随意转移SIM卡到其他设备的流量滥用情况发生。",
    content10:
      "可解决在恶劣的外部物理条件下 (如极高/低温、震动颠簸、长期日晒雨淋，以及SIM卡生命周期比设备生命周期短等) ，传统可插拔SIM卡及卡托性能受影响，及网络连接不稳定等问题。",
    content11:
      "让设备硬件设计不再受限于SIM卡槽，保持机身轻薄。某些设备如资产追踪器，对设备重量、尺寸、空间节省等方面的要求极其严格。",
    content12: "将SIM模块集成到原本的系统芯片 (SoC) 上，优化电池寿命。",
  },
  RedteaReady: {
    title1: "RedteaReady: 针对M2M的全球连接解决方案",
    des1: "网络连接是物联网发展的基础。未来，数以百亿计的设备和物品将基于数据连接产生互联。",
    des2: "作为",
    desLink: "CaaS",
    des222:
      "概念的实践产品，RedteaReady基于不同物联网应用场景为多样化的M2M设备提供连接解决方案，粘合网络侧与应用侧之间的断层，构建可扩展的物联网连接能力。",
    title2: "多样化场景应用",
    app: {
      title1: "更高效的SIM生命周期管理",
      text1: "设备出厂前内置SIM卡功能",
      text2: "消除SIM卡采购及运输成本",
      text3: "远程管理技术提高SIM卡分发效率",
      title2: "更灵活的设备连接管理",
      text4: "设备插电即可获取网络连接",
      text5: "备用网络保障设备在线",
      text6: "连接管理平台提供综合连接管理服务",
    },
    title3: "RedteaReady广泛应用于垂直行业",
    brands: {
      title: "RedteaReady 自有品牌",
      title1: "eSIM模组",
      text1:
        "通过与主流模组及芯片制造商合作， RedteaReady将所有与数据网络连接有关的基础效能封装成统包服务，集成到物联网模组中。用户只需采用已集成 RedteaReady的配套模组，即可轻松获取数据网络连接，随时随地联网，并且可以通过RedteaReady用户控制台实时查看和管理所拥有的设备及订单，使设备商无需再分别为采购模组、采购SIM卡、运营流量花费精力、也无需为网络连接复杂的内部实现方式操心。",
      title2: "RedteaReady USB Dongle",
      text2:
        "搭载了红茶移动eSIM技术的无线上网设备RedteaReady USB Dongle是CaaS概念的实践产品，用户只需将该USB设备插入电脑 (PC与Mac均支持)，即可自由选择全球网络流量服务，套餐设置灵活，即买即用。",
      title3: "RedteaReady CPE",
      text3:
        "基于CPE的高速宽带连接市场需求日益旺盛，红茶移动推出嵌入eSIM方案的RedteaReady自有品牌CPE，可根据设备所处的位置，动态提供灵活可控的网络线路资源。4G转Wi-Fi热点多场景自由移动，具备插电即用、套餐灵活、安装简单、操作界面简洁等特点，支持web、app、API等多种形式。",
    },
    fwa: {
      title: "零售：可云端管理的网络连接方案",
      des: "为零售商提供基于eSIM技术的灵活蜂窝网络连接服务，以代替传统固网和宽带接入方案，或为其提供备用网络，助力零售商户对其商铺连锁网点进行统一，可扩展的店内网络连接管理。",
      title1: "DTU/CPE",
      title2: "Ads Player",
      text1:
        " 把RedteaReady连接能力集成到CPE、DTU等设备中，为门店固网宽带接入方案提供替代或备用网络。部署灵活，可帮助商家节省超过40%的宽带成本以及降低连锁网点连接管理的成本，且可解决使用管理成本高、报装不方便、线路端口资源缺乏等痛点。",
      text2:
        "通过升级广告机通信模组固件，让网络资源可动态灵活调配，解决单一运营商网络信号覆盖在广告机的不同投放网点(如: 电梯、地下室等)参差不齐的情况，通过广告屏幕的远程网络连接管理确保广告内容可以实时更新。",
    },
    auto: {
      title: "汽车： 一点生产，全球连接",
      des: "帮助车辆中有联网需求的各类设备实现在到达目的地后自动连接至当地运营商网络的跨地域、全时域连接，车辆设备在生产阶段无需关心其最终使用地区，无需面向每一个市场预先定制当地SIM卡。",
      title1: "中控",
      title2: "后视镜、T-Box、OBD",
      text1:
        "连接管理平台为车辆中控系统提供包含SIM卡管理、网络资源管理、套餐订购管理等综合连接管理服务。",
      text2:
        "可根据设备所在位置远程动态下发可匹配的本地运营商资源保障流畅网络，支持存量设备的远程整体升级。",
    },
    hand: {
      title: "手持终端： 轻松激活设备连接 ",
      des: "为您的手持终端设备提供可在任何地方使用的便携式设备连接方案。特有的种子资源预埋技术可让设备出厂就具备「插电即连接」的能力，帮助您轻松获取初始网络和远程连接可用网络资源。",
      title1: "POS机",
      title2: "AI 翻译机",
      title3: "Mi-Fi",
      text1:
        "实现POS机开机自动入网，按需进行网络切换和流量管理，操作更加灵活，人机交互更加友好。",
      text2:
        "为翻译机需要频繁跨国跨地区使用的应用场景提供全球自由切换网络支持， 无需实体SIM卡。",
      text3:
        "支持网络资源动态配置，可帮助Mi-Fi设备厂商为用户打造国际漫游、本地资费、随走随连的移动网络体验。",
    },
    log: {
      title: "物流和追踪：保持在线，保持感知",
      des: "基于eSIM技术引入网络冗余概念，强制设备在断网后迅速启动备用网络恢复连接，可为追踪器或定位器等提供保障实时在线的连接体验，确保设备可不间断报告其所在位置，掌握设备去向。 此外，在某些特定场景下， 追踪器对设备重量要求十分严格， 该方案可以将SIM的能力集成到设备里不占空间。",
    },
    uti: {
      title: "公共事业和仪表：打开智能仪表领域的新机遇",
      des: "为可广泛应用于公共事业领域的NB-IoT模组赋能eSIM能力，帮助其带来降低基础网络设施成本，减少安装成本，提高网络安装效率等直接效益。",
      title1: "智能门锁",
      title2: "智能仪表",
      text1:
        "在NB-IoT模组中嵌入RedteaReady eSIM方案可以为智能门锁设备提供更灵活的网络选择，且可提供备用网络保障设备在线，通过app即可实现门锁的远程控制。",
      text2:
        "以智能水表为例，通过为设备提供选择灵活且有保障的网络服务，支持水表设备为水电厂提供账单、实时监控等重要信息，且通过在仪表出厂前将方案嵌入NB-IoT模组中，可极大程度降低网络部署和安装成本，加速安装进程。",
    },
    wear: {
      title: "可穿戴：更小机身设计，更多网络选择",
      des: "以eSIM手表为例，eSIM技术让智能手表成为可独立于手机联网的移动终端，不但可以通过远程下发码号便捷获取网络，还因为不再需要实体SIM卡卡槽大大节省设备空间。",
    },
  },
  AboutUs: {
    gallery: "团队掠影",
    download: "下载红茶移动公司简介",
    title: "红茶移动：一家CaaS公司",
    des1: "红茶移动是富有开创精神的eSIM技术实践者及设备连接方案服务提供商，专注于为全球多样化的物联网设备提供覆盖广泛的蜂窝网络连接服务及一站式eSIM解决方案。我们提供全球超过100个国家及地区的3G/4G网络覆盖，eSIM连接能力已触达2.5亿终端。",
    des11: "",
    des12: "",
    des13: "",
    des2: "红茶移动致力于发展eSIM核心技术在行业领域的实际应用，通过将复杂的底层通信功能和网络连接实现打包成基础服务，为移动运营商、设备制造商、芯片及模组制造商提供创新的产品解决方案及业务合作模式。",
    title0: "使命、愿景，及核心价值观",
    mission: {
      title: "我们的征程始于使命",
      des1: "红茶移动的使命阐述了我们作为一家企业存在的意义，并以此作为衡量我们行动和决策的标准。",
      des2: "把连接变简单，让世界更高效。",
    },
    vision: {
      title: "努力让愿景成真",
      des1: "红茶移动的愿景描绘了我们实现可持续发展和高质量增长的公司，应该成为的样子。",
      des2: "致力于成为世界领先的「连接即服务」公司。",
    },
    values: {
      title: "践行我们的价值观",
      des: "价值观反映了红茶的思想基础，我们吸纳有共同价值观的员工，并以此指导我们做事为人的行为指南。",
      title1: "正直",
      text1: "实事求是",
      text2: "简单直接",
      text3: "平等开放",
      text4: "尊重与充分沟通。",
      title2: "果敢",
      text5: "信任同事",
      text6: "积极向上",
      text7: "负责和严谨",
      text8: "既有团队精神，亦能单兵作战。",
    },
    recog: {
      title: "行业认可",
      des: "自2015年成立以来，我们与客户及用户共同成长，也不断收获一个个里程碑.",
      text1: "GSMA会员；",
      text2: "中国联通eSIM产业合作联盟首批成员；",
      text3: "中国移动物联网联盟成员；",
      text4: "与GSMA在澳门联合举办运营商盛会WAS#5；",
      text5: "《快公司》「2016中国商业最佳创新公司50」 ；",
      text6: "《福布斯》「全球最以用户为导向的100家公司」",
      content1: "GSMA会员",
      content2: "中国联通eSIM产业合作联盟首批成员",
      content3: "中国移动物联网联盟成员",
      content4: "CCSA会员",
      content5: "TAF会员",
      content6: "国家高新技术企业",
      content7: "与GSMA在澳门联合举办全球运营商盛会WAS#5",
      content8: "快公司「2016中国商业最佳创新公司50」",
      content9: "福布斯「全球最以用户为导向的100家公司」",
      content10: "华为AIoT产业联盟成员",
      content11: "英飞凌ISPN合作伙伴",
      content12: "德国电信NuSIM官方合作伙伴",
    },
    partner: {
      title: "成为合作伙伴",
      des: "红茶移动持续在蜂窝网络连接领域发挥业务价值，想知道创新的红茶如何能够帮到正在寻求创新连接解决方案的您，请发送咨询邮件到:",
      des1: "communications@redteamobile.com",
    },
    diff: {
      title: "与红茶一起共同创造不平凡",
      des1: "在红茶，我们欣赏保持好奇心、持续提升自我的员工，鼓励勇于打破常规的大胆创新，与公司一起创造不平凡。",
      des2: "在红茶移动，我们提供丰富的资源和灵活性让你享受工作，并成为更好的自己：",
      text1:
        "福利：年度健康体检、每周健身活动、节日庆祝活动、茶水间免费饮品和零食等",
      text2: "丰富的培训资源",
      text3: "系统性个人成长计划",
      text4: "弹性灵活的工作环境",
      text5: "现在加入吧",
      text6: "欢迎发送简历至:",
      text7: "hr@redteamobile.com",
      job1: "JAVA高级工程师（IOT）",
      job2: "海外拓展经理",
      job3: "运营推广经理（海外C端产品）",
      job4: "高级产品经理（海外C端产品）",
      jobDes1: "按照开发规范，标准、规范、严格地进行系统编码开发；",
      jobDes2: "根据上级主管要求编写符合规范的技术文档及维护手册；",
      jobDes3:
        "根据业务需求负责国际运营商资源采购,商务策略制定,合同谈判,关系维护,账单结算等相关工作；",
      jobDes4: "协调解决业务运行过程中出现的各类运维问题和技术需求；",
      jobDes5: "负责公司整体成本把控，持续提升业务利润率。",
      jobDes6:
        "负责海外C端产品的运营和推广，线上/线下新渠道拓展与维护，合作渠道/媒体的广告投放，推广ROI，达成用户增长目标；",
      jobDes7:
        "负责跟踪运营增长数据，通过营销效果分析、用户反馈结合竞品调研优化运营策略，制定可行性运营方案；",
      jobDes8:
        "协助制定和策划编辑产品宣传文案、广告宣传方案，和发布社交媒体内容等，并定期收集市场宣传推广信息。",
      jobDes9:
        "收集和梳理来自各方的产品需求，结合开发团队的技术评估编写并迭代明晰的产品需求文档（PRD), 移动APP等产品的流程图和原型设计，明确分工，并优化开发顺序和流程；",
      jobDes10:
        "配合市场/商务部门及公司高层对用户/市场/业务的需求进行调研分析并输出文档（MRD）；研究竞争对手，输出竞品调研报告，提供产品策略和运营建议；",
      jobDes11:
        "组织立项会议，协助开发团队理解、掌握需求，跟进开发进度和产品验收；协助运营部门负责产品上线后的数据管理、运营和内容维护工作，提出产品优化方案。",
    },
  },
  ContactUs: {
    des: "感谢您对红茶移动的关注，如有任何问题或想进一步了解红茶，请随时联络我们。",
    title1: "如有问题咨询或希望安排会议交流请联系：",
    email1: "邮箱：communications@redteamobile.com",
    tel1: "电话:  +86 755 2692 6753",
    hour1: "（工作时间：周一至周五上午9:30 - 下午18:30）",
    title2: "如对产品使用方面有疑问请联系：",
    email2: "邮箱：support@redteamobile.com",
    title3: "办公地址：",
    address:
      "新加坡：29 Media Circle #02-14/15 Alice@MediaPolis, Singapore 138565<br/>深圳： 深圳市南山区粤海街道滨海社区海天二路25号深圳湾创业投资大厦903-907",
    introduce:
      "红茶移动是全球领先的全栈式eSIM服务商，苹果官方eSIM服务合作伙伴，在新加坡、中国、荷兰、美国、欧洲办公运营。",
    phone: "联系电话：",
    fax: "传真：",
    singapore: "新加坡：",
    china: "中国：",
  },
  resources: {
    des1: "与您分享红茶移动创新研究，产品发布，全球合作和客户案例等企业动态，欢迎了解我们的新闻动态，掌握eSIM最新趋势。",
    des2: "作为GSMA或Counterpoint白皮书等行业报告的贡献者，红茶移动很高兴与您分享对于行业的预测和展望，以应对企业的风险和机遇管理。",
    des3: "专注于CSP领域，我们对「基于eSIM核心技术的连接服务」进行了全方位的解析，以给您启发，产生新的思维和好的想法。",
    des4: "“CaaS”代表“连接即服务”，“eSIM”代表“嵌入式SIM”,“SM-DP”代表“远程管理和部署平台”，我们整理了一些类似的行业专业用语，以帮助您理解eSIM这个领域。",
    news: "新闻动态",
    report: "行业报告",
    Insights: "观点洞见",
    terms: "行业术语 ",
    FAQ: "常见问题",
    download: "点击下载PDF文件",
    FAQdes:
      "基于红茶移动长期的客户反馈，展会和研讨会的业界讨论，行业权威白皮书或报告的撰稿贡献，我们列举了一系列问题和答案，希望能帮助快速解决您的问题。",
  },
  article0: {
    title: "红茶移动参与推动实施面向IoT领域的集成式SIM方案nuSIM",
    p1: "【新加坡，2020年6月25日】 领先的设备连接方​​案提供商红茶移动 (Redtea Mobile) 积极参与生态创新，与合作伙伴联合推出面向物联网 (IoT) 领域的集成式SIM解决方案 — nuSIM。通过将SIM功能完全集成于系统芯片中，nuSIM在降低材料成本、优化功耗、简化设备整体设计等方面具备明显优势。",
    p2: "此联合解决方案由德国电信提供nuSIM开放规范，红茶移动遵循此规范开发可信应用 (Trusted Application) ，该可信应用能够在包含Qualcomm® LTE 9205芯片的移远BG95模组上安全运行。集成式nuSIM将成为低功耗广域应用的重要赋能者，尤其适用于移动物联网领域使用寿命长，成本较低的设备，如资产追踪器，智能传感器等。",
    p3: "我们很荣幸能与行业领先的合作伙伴德国电信、高通公司，以及移远通信一起，共同致力于用创新技术手段简化蜂窝网络连接部署，向物联网无处不在的目标更进一步，” 红茶移动战略合作与项目副总裁郭晓东表示，“红茶移动的使命是‘把连接更简单，让世界更高效’，通过将SIM功能转移到设备的永久硬件阵列如系统芯片中，并且在模组或设备的生产阶段就预置运营商数据，让最终客户无需任何额外操作就能即刻获取网络连接。",
    p4: "德国电信UICC开发负责人Stefan Kaliner则表示： “德国电信自去年年初推出nuSIM计划以来，基于具备通用性和可互操作性的技术规范，一直与包括红茶移动在内的，各细分领域领先的行业伙伴保持着密切的合作。红茶移动开发的可信应用是遵循nuSIM规范的操作系统，负责接收和处理加密nuSIM码号资源，从而可以为用户提供与实体SIM卡相同级别的安全性。",
    p5: "红茶移动基于Qualcomm 9205 LTE调制解调器提供的可信执行环境 (TEE) 开发的可信应用，作为集成nuSIM解决方案的组成部分，将有助于进一步为全球物联网应用提供可靠、安全和优化的蜂窝网络连接，” 高通欧洲公司产品管理副总裁Vieri Vanghi表示，“我们很自豪能够与红茶移动、移远通信以及德国电信一道，共同促进nuSIM技术的应用落地，这对于发展下一代安全、低成本、低功耗的物联网设备非常有必要",
    p6: "移远通信首席运营官张栋表示： “移远已将Qualcomm 9205 LTE调制解调器和nuSIM操作系统安全地集成在BG95-M3 LTE Cat M1/Cat NB2/EGPRS模组内，打造出具有超低功耗的产品。BG95-M3非常适合POS机、智能表计、追踪器、可穿戴设备等各类物联网终端，在移除实体SIM卡之后能够有效帮助客户减小终端尺寸、节约成本并降低功耗。",
    p7: "关于红茶移动",
    p8: "红茶移动是eSIM核心技术创新与连接方案提供商，聚焦连接效率提升及eSIM场景应用的产业化落地，解决5G时代蜂窝物联网海量部署的关键问题。红茶移动致力于成为全球顶尖的CaaS (连接即服务) 公司，通过将复杂的通信资源抽象成可扩展的连接服务，把连接变简单，让世界更高效。红茶移动成立于2015年，所提供的连接能力目前已触达逾2.5亿设备终端，网络资源可覆盖全球超过100多个国家及地区。旗下业务包括面向手机终端用户的全球上网服务RedteaGO App，针对IoT领域的网络连接部署方案RedteaSIM及RedteaReady, 以及为运营商推出的一站式解决方案eSIM.Plus。",
    p9: '红茶移动自去年底推出针对蜂窝物联网的规模化部署的解决方案<a href="http://www.redteasim.com">RedteaSIM</a>以来，与移动运营商德国电信、芯片制造商高通公司，以及模组厂商移远通信通力协作，联合推出nuSIM项目，成功完成了RedteaSIM从方案概念到实施落地的迈进。nuSIM作为RedteaSIM与众多知名行业生态代表联合推出的第一个成功应用案例，对于红茶移动意义重大。',
    p10: "RedteaSIM 应用场景",
    p11: "举几个例子<br/><br/>01<br/>车联网",
    p12: "如果所有汽车都联网了，即时在线可以回传车辆信息，车况监控，车与车之间会协调路径、距离、速度。出门知道路况，甚至可能实现自动驾驶。",
    p13: "但在停车场，无需频繁切换，而是需要广泛覆盖的稳定网络，采集无数的车位信息。要求网络广泛覆盖整个可停车区域，摄像头，车位桩，车位传感器等数据采集设备布点要充分到位，如果需要人工插SIM卡，换SIM卡，会是不小的挑战。",
    p14: "RedteaSIM在车出厂之前，以安全的方式添加移动运营商数据，实现平台远程空发，灵活选择运营商资源，最终客户无需任何其他步骤即可获得即时连接。解决大规模部署车联网中的繁杂的SIM采购和分发的系列流程，以及碎片化部署等挑战。",
    p15: "02<br/>水表，电表，路灯，工业PC等",
    p16: "RedteaSIM赋予仪表更加智能的通信功能：",
    p17: "功耗： 这些静止的设备，无需随时移动，牺牲了速率，要求更低的功耗，RedteaSIM采用eSIM, 比SIM卡联网功耗更低。",
    p18: "待机：一般的仪表，路灯，工业PC使用期限都可以达到好几年，无需人工换卡，人工维护，远程配置码号资源。",
    p19: "规模部署：连接数量方面，以上设备均是工业级联网所需，大规模，广覆盖，无需人工插卡。",
    p20: '更多RedteaSIM详细信息请访问：<a href="http://www.redteasim.com">www.redteasim.com</a>',
  },
  article1: {
    title: "Forbes专栏文章【“最以顾客为中心”的100家企业】",
    p1: "作者：Blake Morgan，Forbes资深撰稿人,Network CMO，客户体验主题演讲人，未来主义者和两本书的作者，包括《未来的顾客》",
    p2: "以客户为中心不仅仅指的是提供优质产品或配备客服中心这么简单， 而是会潜移默化地成为一种企业文化，并且影响着员工工作模式到客户体验的一切。以顾客为中心的公司时刻密切关注着客户，不断观察其行为习惯，并极度聚焦在顾客身上，从而创造了一些了不起的用户体验。",
    p3: "以下这些是具有创新性的企业，甚至在世界范围内都建立了品牌影响力。这些企业颠覆了他们所处的行业，并且不断发展，收入不断攀升。拥有卓越用户体验的品牌带来的收入是竞争对手的5.7倍。不断在用户体验方面进行投资的企业，可以看到其明显的财务收益，并且能够强烈感知到其以顾客为先的企业文化。",
    p4: "如今，许多企业都在逐步开展数字化转型的工作，这是迈向达到“以顾客为中心”的企业文化的第一步。据IDC研究报告表明，85％的企业决策者表示，他们愿意花长达两年的时间，在数字化转型方面取得重大进展，否则他们将远远落后于竞争对手，并且造成重大的经济损失。",
    p5: "“以顾客为中心”可以体现在很多方面，从采用新技术，获得用户反馈，到和用户建立关系都是企业在聚焦用户体验方面做的努力。以下列举了100家在以用户为中心方面称得上是“最佳实践”的企业。这些企业有些获得了用户服务相关奖项，有些在用户满意度调查排行榜上位居前列，有些被评为专注于员工体验的最理想工作场所。他们来自10个不同的垂直领域，包括",
    p0: "零售，金融，医疗保健，B2B，软件，餐旅业，保险，电信，制造业，农业",
    p6: "这个时代对于媒体，娱乐和电信领域都是一个有趣的时代。人们希望无论走到哪里都能随时随地联网，获取互联网咨询，这对于电信企业和那些为消费者提供电信体验的B2B公司产生了巨大的场景应用机会点。研究表明电信企业正在努力积极进行数字化转型 - 许多客户体验不能以数字化开始，最终以线下零售实体店的形式呈现，反之亦然。但是，电信行业仍然有十家企业因以客户为中心而广受好评。（披露：Verizon是我的前客户）",
    p7: "1.Dish Network.面对快速迭代变化的电信业，Dish会不断倾听客户意见，并不断调整其产品以满足他们的喜好。",
    p8: "2.Boost Mobile. 拥抱多元化，并鼓励经销商参与其社区。",
    p9: "3.DIRECTV. 因为综合客户满意度和优秀的品牌传播，在J.D.Power上占有很高的地位。",
    p10: "4.Redtea Mobile.颠覆电信行业的创新，红茶移动的云服务技术让设备可以根据地点更换可以更换网络，这会解决很多客户的痛点。",
    p11: "5.TELUS. 客户获得支持和帮助的形式多样化，对于任何可能出现的问题，从线上教程都可以获得详细说明。",
    p12: "6.Republic Wireless.平均客户体验分提高了90%，很大一部分是因为一些电话的接听者是已经变得很专业的客户，这让整个体验感更加个性化。",
    p13: "7.Consumer Cellular. 因为不用和运营商绑定签合同，获得最佳客户服务的赢家，个性化的服务让顾客通过多种渠道获得帮助，其中包括一个AI的聊天机器人。",
    p14: "8.Verizon.将AI和人工结合起来，以为客户创造一个十分个性化，并且可以多种渠道获得的强大的客户体验。",
    p15: "9.Sling.创新服务让客户即使切断网络，也不会错过他们喜欢的网络和电视节目，并且通过AI来时刻获取客户反馈，提供高效响应服务。",
    p16: "10.Netflix. 因为直播服务一直居ACSI评价榜榜首，Netflix充分了解其客户属性，并且充分利用数据分析得出观众真正最想看节目的反馈，在最近的采访中，Reed Hastings表示他们想要在客户体验上做到别具一格，这也是未来赢得市场竞争的唯一方式。",
    p17: "财富对人们来说是一种情感化的东西，而现在的金融企业正在不断向前发展，开创潮流，努力为用户创造更加简单便捷的财富管理服务。隐藏费用，透支消费和高利率的学生贷款都让消费者们头痛不已。金融科技初创企业在创新方面处于领先地位，采用软件方式来不断促进银行和金融服务发展。以下列举了十家在以消费者为中心方面做得及其到位的金融企业：",
    p18: "1.Citizens，作为Temkin 体验评价榜上的领先者，采用长期策略，绘制客户购买路线图，预测客户需求。",
    p19: "2.Ally Bank在Forrester 顾客体验指数上得分很高，和其他数字导向型公司合作，提供端到端用户解决方案。",
    p20: "3.Navy Federal Credit Union.连续四年因为顾客体验位居“名誉企业”的先列地位，公司员工全体以客户为中心，且清楚知道自己在这一工作中的角色定位。",
    p21: "4.Huntington National Bank花了两年时间倾听客户，打造数字银行中心，帮客户理财，并且设立自己的财务目标。",
    p22: "5.Charles Schwab利用数据理解客户，紧跟趋势，提供前卫的理财方法。",
    p23: "6.Edward Jones，各级员工都有发言的机会，推动着全公司以客户为中心。",
    p24: "7.Discover.采用尖端AI技术和人工互动，准确抓取需要财务支援的时机。",
    p25: "8.ING.公司全体发力，各部门组织合作提出创意的以客户为中心的好创意。",
    p26: "9.Capital One.互相信任，公开透明的企业文化，每个员工都在“以客户为中心”方面有所贡献.一家只有31年历史的年轻银行，然而资产已经达到3720亿，创始人兼CEO仍然是 Richard Fairbank。",
    p27: "10.Chase 是第一家转向移动服务的银行，为客户提供全自动流程，就地全部解决的客户体验，我就是他们的客户，也从一开始就一直很喜欢他们的移动或个人银行服务。",
    p28: "如今的企业必须用以人为本的方式对待客户，面对一群客户，不能仅仅采用进行批量操作的方式。以远程医疗的增长领域为例，根据美国医学协会和美国健康委员会的统计数据表明，近75％情况下，申请“紧急护理”和“急诊就诊”的医生就诊都是不必要的，其实可以通过电话或视频就可以安全有效地处理病患情况。以下是十家非常人性化的医疗保健企业。",
    p29: "1.One Medical.对会员的收费合理，并且把病房改造成舒适放松的套房，提供休闲服务。",
    p30: "2.Kaiser Permanente.对员工和客户同样上心，利用类似虚拟预约的创新技术让医者可以方便地一次性面对很多病患。",
    p31: "3.Propeller.采用GPS定位技术，为哮喘病患者提供更好的治疗方案。",
    p32: "4.UCB. 采用AI技术的app, 让帕金森患者可以7*24小时都有人看护，还能监控看护情况。",
    p33: "5.Acxiom跟踪了4400位病患恢复的原因，让医生主动与其联系，从而直接产生转介绍。",
    p34: "6.RDMD. 采用AI技术分析医疗数据，找出罕见病患联系方式，为有需求的患者快速研究出创新的治疗方案。",
    p35: "7.VRHealth. 采用虚拟现实技术，让病患在一些紧张和有压力的过程中可以保持冷静，才能更好地配合治疗。",
    p36: "8.CloudCare.让医护团队的所有成员，都可以快使实时看到数据，大大提升医生和患者的沟通效率，并且数据传输绝对安全加密。",
    p37: "9.Solv.概念很简单: 搜集一天中可以约上的所有优质医生，全渠道发布信息，让客户可以快速约上看诊。",
    p38: "10.Novo Nordisk.“以事业意义为驱动的企业文化，鼓励每一位热情服务糖尿病患者的员工。",
    p39: "现在全世界B2B公司比B2C公司更多。事实证明，只有14％的B2B公司拥有以客户为中心的企业文化。（披露：思科是我的前客户）",
    p40: "1.Slack. 专职认真的客户体验团队帮助客户成就自己的事业，不断倾听，不断调整，时刻保持服务意识，并且保持相当于对方CEO的态度为客户操心大局。",
    p41: "2.DHL. 公司重组一轮，来打造更加有凝聚力，对员工友好的企业文化，从而达到更满意的客户和更好的服务。",
    p42: "3.Qumulo.深入围绕客户反馈，并且持续深化服务，满足客户需求。",
    p43: "4.Paycor.这家招聘服务商经营一个HR精英中心，这个中心的主要目的就是帮助客户获得成功，并且持续倾听客户反馈，解决客户问题。",
    p44: "5.FedEx.在技术上一直保持领先地位，提供快速，可靠的运输服务。",
    p45: "6.Level 3. 内部重组来避免silos仓储，是考虑到用户体验做出的设计，旨在创造更易获取，更愉悦的用户体验。",
    p46: "7.Cisco.经历了大量的技术变革，其产品已经云化，并且开发出可供订阅的模型，来更好地满足客户需求，最近还创立了一个2万7千人的顾客体验群，这在客户体验的改革方向上是一个重大举措",
    p47: "8.Wells Fargo.这家银行的商业战略正致力于帮助中小企业获得成功，并且在各行各业提供企业成长的培训和支持，不止是金融业。",
    p48: "9.GE. 2B的客户能够在两个客户服务中心看到其产品和服务，在一种轻松的体验环境中展示了其品牌产品，并且还会提供个性化的推荐服务。",
    p49: "10.Motorola.其B2B事业部和客户建立了一种情感关联，通过辨别客户的重要时机，在业务的关键时期提供难以置信的帮助。",
    p50: "许多以顾客为中心的企业都是软件和技术公司。这些企业的创始人一般就是CEO，也是第一批迈入数字化时代的企业。客户喜欢智能手机和其他设备带来的生活便利，而科技公司恰好能满足这一需求。我们消费者最喜欢的体验常常来自于包括谷歌，苹果，亚马逊和Netflix等科技公司用技术实现的体验（披露：Adobe是我以前的客户）。市值排名前十强的企业中有一半是科技公司。",
    p51: "1.Workday.清楚地知道满意开心了的客户是最好的推荐人，并且常常把客户的利益放在决策的第一位。",
    p52: "2.Google获得了软件公司的ACSI指标的最高分数,因为其员工充分了解全线产品，并且能够随时帮助客户解决问题。",
    p53: "3.Rackspace.热诚支持在Rackspace不仅仅是口头说说，它是公司每个员工为客户满意度所做出的承诺和一种处事方式。",
    p54: "4.Adobe.被称为是一个很好的工作环境, Adobe鼓励员工给予反馈，并且不断持续投入努力提高客户满意度。",
    p55: "5.Apple.员工采用3个F作为指导原则，去感受, 感受到了以及被感受到了，来移情，并且帮助客户为提升生活而创造的完美的技术方案。",
    p56: "6.WPCurve. WordPress支持服务涵盖客户业务的方方面面，并且有线上支持不断帮助客户取得成功。",
    p57: "7.DreamHost.所有客户，不管消费多少，都会受到很不错的对待，并且会为客户提供定制化的个人帮助和支持。",
    p58: "8.Ximble.不同于一般的呼叫中心，这家公司的客服大部分在家工作，并且本身就是顾客的身份，所以对于客服电话接听有更丰富的经验",
    p59: "9.LinkedIn.员工更喜欢在一家意义导向的公司工作，而实践表明，领英为其客户绘制了顾客体验路径，为客户找到痛点并且提供个性化服务的解决方案，而从2007开始使用领英开始，我的整个事业过程的开拓大部分要归功于领英。",
    p60: "10.Fast Enterprises.员工和家庭占据企业重心的首位， 这也促使企业发展出顾客优先的企业文化，员工会和客户建立私人关系，并陪伴他们经历软件开发过程中的低谷和高潮。",
    p61: "客户体验和旅行是最佳伴侣。今天，人们对于体验的消费高过物质消费，大部分人为了旅行存钱。随着旅游业竞争的加剧，酒店越来越重视建立客户忠诚度。事实上，去年在客户忠诚度上排名前5的企业在用户忠诚度上的投资从30％增长到了47％。（披露：Fairmont是AccorHotels的一部分，也是我前客户）",
    p62: "1.Montage.让豪华旅行提升了新高度，配置超级豪华，由全公司各个部门的精英员工提供服务，服务无可挑剔。",
    p63: "2.Hilton.让一线员工负责给予客户反馈，同时给这批员工开放数据，来为每位客户主动提供个性化的服务。",
    p64: "3.Yelp.饿了吗？打开Yelp! 今天这个时代我们不用因为赶时间而计划缜密，到达一个新城市，只要打开Yelp就能找到好食物.而我们更信赖客户的胃，而不是市场营销专家们。",
    p65: "4.TripAdvisor.移动端app和当地搜索都为客户的旅途体验提高了极大的便利性，每次去到一个新的地方， 我搜索酒店湖泊当地体验时，都会优先看TripAdvisor上的评论，因为其服务覆盖了到了全球， 所以很受环球旅行者的欢迎。",
    p66: "5.Alaska Airlines. 连续11年被 J.D. Power评为美国航线最佳用户体验创造者，一直专注于倾听和回复每一位顾客。",
    p67: "6.Delta Airlines. 从头到尾客户一直处于企业的中心地位，包括移动端的订购服务，大量的休息躺椅，以及航班准点的可靠性，都是为了更好的用户体验而设计。",
    p68: "7.Fairmont Hotels.这家酒店推行了一系列可持续服务的实践，包括一些生态环保的设施建设，获得LEED认证的一些建筑，都深受客户喜爱。",
    p69: "8.Tribute Hotels.只是在基本的满足客户需求之上发挥了一些空间，为客户提供可一种独一无二的独特体验。",
    p70: "9.EVEN Hotels.这个以健康为重点的连锁酒店让客户在旅行途中也能保持健康，同时身心放松，并且为了这个目标，酒店的方方面面都围绕着帮助客户保持活跃，轻松获得好的休息，愉快进餐，而做出相应的设计。",
    p77: "10.Lyft. 这个拼车公司以数据分析为中心，不断为客户规划开发更快更安全的路线，同时满足客户轻松出行的偏好。",
    p78: "做保险的企业确实有可能，在客户刚好需要的时候挺身而出，维护其权益，但要达成上述目标的过程仍然很漫长。以下列举了十家为客户的需要做好了提前准备的企业（披露：Allstate是前客户）。",
    p79: "1.USAA几乎获得了每一个和顾客有关的奖项，因为其员工真正关心用户，并且不断被鼓励大胆说出想法。",
    p80: "2.Erie Insurance在Forrester’s Customer Experience 指数上排名领先,一直坚持创新的数字化解决方案，谦逊，以客户为中心的企业文化。",
    p81: "3.Allstate设置了一个内部自动程序(Amelia),让企业员工快速获取最新资讯，从而让他们可以为客户提供精准个性化的服务。",
    p82: "4.Liberty Mutual. 产品教育是获得好的体验的第一步，通过Alexa的语音指令，Liberty Mutual让客户轻松获取保险业的报价和信息。",
    p83: "5.Thrivent Financial. 被称为是全球最有职业道德价值观的企业，企业社会责任感强，极度关心客户需求。",
    p84: "6.Next Insurance.用AI算法结合人工，把政策和流程自动化。",
    p85: "7.Metromile.颠覆行业创新，提供按每公里付费的保险服务。",
    p86: "8.Geico.24/7小时都有专业的代理和网上机器人回答问题，带客户走一遍流程。",
    p87: "9.Slice.开辟出新的一项服务，为提供假期短租的屋主提供切实满足需求的保险服务。",
    p88: "10.Lemonade. 流程透明化，让客户看到理赔生成流程，未成功的理赔进入客户选择的慈善机构。",
    p89: "我们创造产品的方式对客户的产品体验有很大影响。从b2b和b2c的角度来看，制造业很有可能极大地影响客户体验。（披露：派克是我的前客户）",
    p90: "1.Subaru. 在车生产的安全，可信赖度，以及主动客户解决问题上，一直保持透明化，获得广泛认可。",
    p91: "2.LG. 这家家电厂商一直因为创新意识上榜，不断开发出对用户友好的产品特征。",
    p92: "3.Hilcorp.各层级员工都能发声，并且会付诸实践，为顾客创造更好的体验。",
    p93: "4.Caterpillar. 顾客体验的排名榜冠军，得益于其全体公司员工向前冲锋的主动性，和一个也不落下的团队意识。",
    p94: "5.Parker Hannifin.持续性地提供数字化服务和全渠道体验服务，并且定期和客户保持联系。",
    p95: "6.Porsche. 这家豪华车制造厂在“客户满意度”上排名第一，主要归功于其提供的个性化的销售服务和优质的产品。",
    p96: "7.Graco Inc.  这家医疗设备企业因为独有的办公环境和社区氛围，工作环境算得上是首屈一指。",
    p97: "8.Graco Inc. 踏实创新的企业文化让员工不断尝试新事物，同时倾听客户反馈。被评为2018年最佳工作场所。",
    p98: "9.Michelin.为员工赋能，采用新技术来让其更好地完成工作，同时让员工和全球员工和客户建立联系。",
    p99: "10.3M. 员工感觉到被信任和有归属感，从而会不断创造满足客户需求和解决未来问题的创新产品。",
    p100: "以客户为中心的要做到时刻感知，观望全球，这意味着企业时刻关注着地球上所发生的事物。消费者需要更加可持续的商业模式，以下是十家提供服务的公司：",
    p101: "1.Indigo.用技术赋能农业开展，做数据分析，同时持续种植一些普遍作物（如棉花和大米）。",
    p102: "2.Impossible Foods.完全用植物制作的汉堡的创新者，为人们创造出真正想吃的环保食物。现在已经遍布全国，而且非常畅销。",
    p103: "3.Bright Farms. 这家公司通过创建全国各地农庄的室内温室，把新鲜的农作物带给大家，而且采用技术手段，可以实现节省水，土地，燃料等资源的方式来生产作物。",
    p104: "4.OmniEarth.采用简单的方法：利用虫子生产出的有机的草坪肥料，保障可持续性发展，创新又环保。",
    p105: "5.EarthSense. 用机器人和AI监测农作物受灾害情况，减少或抑制化学品的使用。",
    p106: "6.Bayer. 大量投资在培训教育上，让全世界的农民都学会更利于可持续发展的操作方式，以减轻世界饥饿问题。",
    p107: "7.Good Eggs.食品运输服务只供应当地可持续生产的食物，并且以让土地，动物和顾客保持开心为首要目标。",
    p108: "8.TeleSense.采用IOT监测储存谷物的温度和环境，提升庄稼种植的保鲜率，提高存活率。",
    p109: "9.Freight Farm. 提出在货物集装箱中创造出土地的创新理念，让大众生产出新鲜作物，尤其在拥挤的城市区域。",
    p110: "10.FarmOp Capital. 基于一些贫困客户的需求，给一些没有土地收割权的农户提供资金贷款。",
    p111: "如今的用户在其生活的某些领域可以获得一些非常个性化的客户体验，而在其他领域获得的体验非常普通。对于零售商来说，最关键的核心问题是如何利用好今天获取到的数据？87％的移动营销人员表示，使用地理区域定位可以获得更多用户互动和更深刻的客户洞察。",
    p112: "1.Wegmans.  集中创造快乐的工作氛围。",
    p113: "2.Trader Joe’s. 会为顾客做任何事情，包括开箱送礼品。",
    p114: "3.Glossier. 客服部整合进市场部，鼓励客服人员不断倾听，分享客户独特的体验，故事和建议。",
    p115: "4.Warby Parker. 数据分析和有特色的销售体系让顾客可以享受1对1专属服务，顾客不用重复说明自己的喜好。",
    p116: "5.Sephora. 用科技打造一个功能全面的app, 让顾客享受线上体验试妆，以及无缝对接的线上社群服务。",
    p117: "6.Amazon. 电子商务的巨头企业，不断研发创新的顾客体验解决方案，包括一天到货，轻松返, 根据所处位置提供真正的全渠道服务等。",
    p118: "7.Casper. 不做实体店，但是线上品牌提供了一个午休室供客户体验，而不是打广告催着客户买新床垫的感觉。",
    p119: "8.Away Luggage.客户反馈推动着公司的每一项决策，打造信息全面的客户个人档案，以提供个性化服务。",
    p120: "9.Best Buy. 从数字化改革到不断深入研究趋势，再到整合简化线下线上体验，以提供个性化服务，甚至包括拜访顾客的家来获得最好的技术服务。",
    p121: "10.Target. 改造实体店来配合线上和app的互动体验时,坚持以用户为中心，展示顾客想要的产品，模糊实体和电子商务的边界，打造全渠道的无缝购物体验。Target之前将其网站外包给Amazon，作为Amazon网站的一个分支，之后在2011收回来并且经历了一场数字变革，在去年的节日季有了实际收益。",
  },
  article2: {
    title: "Redtea Mobile 的eSIM能力部署在全球2亿台设备上",
    p1: "通过提供各种蜂窝连接解决方​​案，为消费者和M2M市场提供服务。",
    p2: "在这个万物互联的时代，未来几年全球范围内数十亿个对象和设备将接入网络。 Redtea Mobile将自己定位为“设备连接服务商”，为“一直在线”的世界提供经济省心的解决方案，打通运营商和消费者的最后一公里。",
    p3: "Redtea Mobile将致力于打造eSIM整体解决方案，包括与蜂窝连接相关的所有服务，比如可以实现远程配置服务和全球蜂窝数据覆盖的嵌入式SIM，更好的运营商订阅管理服务，更简单省心的用户旅途，并使OEM和运营商更轻松地进行物流",
    p4: "我们通过eSIM IoT解决方案提供量身定制的服务，以满足各种应用场景的要求，并提供全球物联网连接，例如：①RedteaRoaming将eSIM功能和数据漫游服务提供给智能手机。②RedteaReady用于扩展大规模物联网连接。③eSIM+（eSIMPlus）是支持eSIM的iPhone最开放的电子eSIM卡市场。",
    p5: "通过“Redtea Roaming”轻松实现国际旅行嵌入Redtea Roaming服务的设备将根据用户的位置自动创建虚拟本地SIM卡。它为您的海外旅行和商务旅行提供方便快捷的数据网络服务。无需物理SIM卡，只需点击几下，即可激活并享受全球移动网络服务。 Redtea漫游解决方案自2015年以来在中国广泛部署，涉及广泛的智能手机，包括OnePlus，OPPO，vivo，XIAOMI，联想，三星中国和hmd（诺基亚）等。此服务也已在泰国等其他亚洲国家推出自2017年以来，马来西亚，印度尼西亚，印度和菲律宾以及美国和欧洲市场以及OnePlus，OPPO和vivo在上述市场推出新智能手机的推出。您可以访问For Consumer Electronics以了解更多信息。",
    p6: "“eSIM.Plus”是数字eSIM卡最开放的市场",
    p7: "最新的iPhone对eSIM的支持开启了运营商和原始设备制造商的繁荣市场。像esim.plus（eSIM +）这样的一些技术产品已经引领着利用Apple eSIM机会的方式。 eSIM +提供开放市场，支持MNO / MVNO快速部署eSIM解决方案，并为eSIM特色iPhone用户提供多种电子eSIM卡",
    p8: "eSIM +愿意为全球的MNO / MVNO引入新的eSIM商机，成为其市场社区的一部分，从而为客户提供更广泛的eSIM卡选择和更大的eSIM服务选择自由。通过提供完全符合移动运营商GSMA标准的标准SIM配置平台（SM-DP +平台），eSIM +帮助他们快速部署适用于iPhone和其他eUICC终端的eSIM商用解决方案，实现运营商，特别是中小型运营商大型MNO和MVNO，在eSIM应用和跨境工作方面拥有公平的商机。",
    p9: "另一方面，非常简单的网络平台使最终用户能够极其方便地购买即用即付本地连接，并在涵盖60个国家和地区的多个移动数据计划之间切换2018年的新iPhone，而无需等待要发货的物理SIM卡。用户只需扫描QR码即可通过无线方式激活eSIM，无需担心本地运营商是否支持eSIM。用户在不同蜂窝数据之间切换的方式与使用Netflix在不同频道之间切换一样简单",
    p10: "请访问",
    p101: "https://esim.plus/",
    p102: "了解更多信息，或联系",
    p103: "bd@esim.plus",
    p104: "进行任何其他咨询。",
    p11: "“RedteaReady”可以实现您的大规模物联网部署可扩展性",
    p12: "您是否正在为您的设备寻找一种连接服务，以便在没有任何前期成本的情况下实现有保证的蜂窝网络？此外，您的设备不再需要在工厂中为其目的地进行定制。不再需要在工厂中订购，构建和测试MNO特定的SIM卡或配置文件。如果您的答案是肯定的，那么由RedteaReady提供支持的连接模块就在这里达到或超过您的期望",
    p13: "RedteaReady Service可以以实用的方式解决初始网络连接的问题。具体而言，RedteaReady Service将eSIM功能与内置的一组SIM配置文件捆绑在一起，以提供作为服务的连接。我们已经在Android，Linux以及运行Qualcomm或MediaTek基带处理器的RTOS操作系统之一上实施了该服务，我们预计不会花费大量精力将其移植到更多其他平台并提供全球物联网连接。该服务使用一组固定的内置SIM配置文件，无需个性化;因此，只需将服务集成到不同模块供应商的固件中，并且不需要对其制造过程进行修改，这使得也可以通过无线方式升级市场中的现有设备。",
    p14: "对于可以是设备操作系统或第三方应用程序的客户端，RedteaReady Service提供API以简单地建立有保证的蜂窝网络连接，其中使用的时间量和可用数据量是可配置参数。用于建立连接的实际SIM配置文件将根据当前位置从最佳可用操作员中选择，但客户端不需要担心，因为它们全部自动发生",
    p15: "RedteaReady支持从设备初始使用的即时数据连接，在整个设备的生命周期内提供移动订阅管理。",
    p16: "转到“M2M设备”以查看详细信息。向我们发送查询，让我们有机会了解您的具体要求。",
    p17: "关于红茶移动",
    p18: "Redtea Mobile是一家eSIM服务提供商，通过eSIM IoT解决方案提供交钥匙解决方案，并致力于全球物联网连接，包括全球蜂窝数据覆盖，RSP（远程SIM配置）平台，eSIM终端技术和基于eSIM的应用。 Redtea Mobile开发了一个完全符合GSMA eSIM标准的RSP平台，并通过与设备OEM，芯片组和模块制造商以及移动运营商密切合作，努力促进eSIM技术的广泛部署和安全实施。 Redtea Mobile被Fast Company Magazine评为“2016年中国最具创新力50家公司”之一。 Redtea Mobile与GSMA联合举办了WAS＃5。有关Redtea Mobile的完整故事，请访问我们是谁。",
  },
  article3: {
    title: "红茶移动发布RedteaReady支持IoT规模化部署",
    p1: "从一站式eSIM解决方案提供商到海量物联网设备连接器，实现连接即服务（CaaS）.",
    p2: "【2018年6月30日，上海】 一站式eSIM连接技术提供商红茶移动在6月27-29日上海世界移动大会 (2018 MWC上海) 期间正式发布针对海量物联网设备的 “连接即服务 (CaaS, Connectivity as a Service) ” 方案－RedteaReady，该方案可支持大规模物联网连接部署的可扩展性。在本届大会上，红茶移动还展示了其将RedteaReady™服务集成于物联网模组上的应用程序示范产品。",
    p3: "未来，全世界数以百亿计的设备和物品将基于数据连接产生互联。在此背景下，红茶移动前瞻性的提出 ”CaaS (Connectivity as a Service)－ 连接即服务”的概念。与云计算中SaaS (Software as a Service) 和 PaaS (Platform as a Service) 类似,",
    p333: " CaaS针对物联网和设备终端领域，其核心要素是把连接和与连接有关的能力作为基础效能(Utility) 服务，通过标准接口开放给智能设备及第三方应用。",
    p4: "基于此概念，红茶移动以eSIM连接技术作为突破口，推出RedteaReady，把从网络流量、远程SIM配置、终端系统集成、连接服务管理平台，及相关配套服务等所有与数据网络连接相关的环节封装成统一服务，集成到物联网模组中、或以标准API的方式开放给智能设备及第三方应用。RedteaReady™旨在为海量的设备连接提供更高集成度、更高分发效率，及更低成本的解决方案，以满足物联网领域对设备连接更高要求、更易规模化部署不断增长的需求，打通大规模物联网应用和设备连接实现的上下游。",
    p5: "简单来讲，客户只需采用已集成 RedteaReady™的配套模组或标准 API, 即可轻松获取数据网络连接, 随时随地联网，并且可以通过用户控制台实时查看和管理所拥有的设备及订单, 无需再为与网络连接相关的复杂繁琐的实现方式操心。",
    p6: "“与手机等消费电子设备可以由用户操作不同，很多物联网设备是无人值守的，没有交互界面，它们是“被动式”的，也不会“投诉”，所以在网络与终端，在运营商与终端设备商之间还需要一个粘合剂，我认为这是红茶移动作为‘连接服务’技术供应商的核心价值。” 红茶移动CEO兼联合创始人金辉博士把RedteaReady比喻为“海量物联设备连接器”。",
    p7: "CEO金辉博士还表示：",
    p777: "“此外，物联网终端和应用多样化，跨地域、跨运营商之间的互操作频繁（例如车联网、全球资产追踪等），如何整合‘碎片’，统一‘接口’，提供无缝的物联网连接，在eSIM时代大有空间可发挥。我们不断追求为设备制造商提供更加完整和集成的解决方案，确保其更便于集成，减少物理空间需求，提高单位成本效益。RedteaReady属于业界先驱，将有望为大规模物联网部署及应用带来质的飞跃。”",
    p8: "RedteaReady™模组供应商合作伙伴移远通信华南区销售总监张震表示：“作为全球嵌入式蜂窝模组领域增长速度较快的供应商之一，移远通信企业愿景的一个重要方面是为大规模物联网应用寻求新型标准和创新技术。 我们和红茶移动的合作示范了数据网络连接在物联网模组上的无缝运行，可同时满足与现有移动运营商基础架构和设备制造商的快速集成，解决不同场景下物联网碎片化应用的困扰，而且不影响模组生产的现有产线产能和成本，形成一个多赢的局面。”",
    p9: "据悉，在此次移动大会上，红茶移动还携其可应用于车联网、新零售、智能制造等物联网场景的连接方案，以及应用于手机终端的国际漫游服务产品参展，并在中国联通展台上展出为其提供技术方案的eSIM 产品。",
  },
  article4: {
    title: "红茶移动携设备连接可扩展方案及应用案例亮相高通4G/5G峰会",
    p1: "【2018年10月24日，香港】一年一度的高通4G/5G峰会在香港成功举办，为期三天的峰会聚焦5G、物联网、 人工智能、 网络连接、延伸移动服务，及软硬件系统等主题，吸引了全球运营商、设备商、技术方案商等众多上下游合作伙伴参与。红茶移动作为高通公司的长期战略合作伙伴再次受邀，携赋能设备可扩展连接的解决方案——RedteaReady™️及可应用于智能模组、新零售、智能制造等领域的场景案例，以及应用于手机终端的国际漫游服务产品亮相峰会展示单元。",
    p2: "红茶移动在2018高通4G/5G峰会上展出赋能设备可扩展连接的解决方案",
    p3: "新零售：RedteaReady™️无线连接取代传统固网，为商家提供4G商用网络连接方案。",
    p4: "目前零售门店普遍采用的固网宽带接入方式存在使用成本高、管理成本高、报装不方便、物业垄断、线路资源缺乏等痛点。红茶移动联合国内行业先驱地位的商用Wi-Fi网络架构及媒体服务提供商迈外迪推出云宽带产品，把RedteaReady™️连接能力植入模组，并统一集成到迈外迪路由器中，为商家提供网络接入和组网方案，可灵活部署，插电即用，可根据网络环境差异确保设备始终在线，可帮助商家节省超过百分之四十的宽带成本。此外，连锁门店可以通过总部统一申请，并统一在平台上进行设备和资源管理，管理成本也可大幅降低。此举将eSIM技术创新应用于新零售领域，为连锁门店解决实际困难，属行业创新。",
    p5: "智能制造：一点生产，全球发货。",
    p6: "红茶移动提供的RedteaReady™️连接能力可支持设备在生产阶段无需关心其目的使用地区，落地即用，可根据设备所处的位置实时下发本地运营商资源获取流畅稳定的网络连接，且资费更加便宜，轻松实现一点生产、全球发货，或一点生产、全球使用。以AI翻译机为例，红茶移动可为设备提供覆盖全球的流量资源保障，无需用户插入SIM卡或连接Wi-Fi即可动态获取蜂窝网络资源，以支持设备多种语言互译、方言翻译、离线翻译、拍照翻译等多种功能，系统流量和用户流量分别计算。",
    p7: "国际漫游：基于eSIM能力的漫游服务已触达逾12个知名手机品牌、1亿终端。",
    p8: "据悉，截至今年10月NokiaX7和X6版本系统支持红茶移动提供的国际流量服务，红茶移动的eSIM连接能力已支持超过12个手机品牌。在去年的4G/5G峰会上，红茶移动展示了其将eSIM搭载于具有集成式UICC (iUICC) 概念功能的高通骁龙835开发板上的应用程序示范产品，也正积极与高通合作，研发基于高通物联网芯片的eSIM部署能力。",
    p9: "红茶移动联合创始人兼CEO金辉表示：",
    p999: "“物联网终端和应用多样化，跨地域、跨运营商之间的互操作频繁，如何整合‘碎片’，统一‘接口’，提供无缝的物联网连接大有空间可发挥。我们不断追求为设备制造商提供更加完整和集成的解决方案，确保其更便于集成，减少物理空间需求，提高单位成本效益。我们期望通过与高通公司等行业巨头的深入合作，巩固增强芯片和模组侧的能力，为海量设备的连接部署及应用带来质的飞跃。”",
  },
  article5: {
    title:
      "红茶移动 : 从eSIM技术到场景实现，放大连接的应用价值 MWC19上海 6.26-6.28",
    p1: "【2019年6月28日，上海】一站式设备连接方案提供商红茶移动 (Redtea Mobile) 四度亮相世界移动大会 (MWC19上海)，继去年提出行业概念“连接即服务 (CaaS, Connectivity as a Service) ”并发布针对海量物联网设备连接的RedteaReady服务后，今年集中展出CaaS在车联网、新零售、智能制造等众多物联网垂直领域的应用成果。",
    p2: "未来，全球数以百亿计的设备将基于网络连接产生互联，在各类应用场景的推动下，物联网领域对设备连接规模化部署的需求不断增长。作为eSIM应用的先锋实践者，红茶移动于2018年前瞻性的提出CaaS概念和RedteaReady服务，将所有与蜂窝网络连接有关的能力集成打包, 向设备制造商和应用服务商提供插电即连接、保持在线、连接可编程的一站式无忧连接体验，并付诸于垂直细分领域的产品化实践。",
    p3: "本次展会直击络绎不绝的伙伴和关注者，一起来回顾问题集锦，感谢每一位用户的反馈！",
    p333: "",
    p444: "",
    p4: "“红茶移动把 ‘把连接变简单，让世界更高效 (Simplify connectivity for a more productive world.)’ 作为企业使命，不断努力在业界推广CaaS概念，并在近两年持续投入物联网连接解决方案的应用实践，针对消费电子领域的RedteaGO国际漫游服务也处于精细运营和稳健增长中。” 红茶移动联合创始人兼CEO金辉博士在展会期间同步举办的eSIM论坛上表示，“与手机等消费电子设备可以由用户操作不同，物联网设备通常是无人值守的，没有交互界面，它们是‘被动式’的，也不会‘投诉’，所以在运营商网络与终端连接应用之间还需要一个粘合剂，我认为这是红茶移动作为‘连接即服务’方案供应商的核心价值。”",
    p5: "CaaS",
    p6: "问：红茶移动提出CaaS的概念具体指的是？",
    p7: "金辉博士认为CaaS将会和PaaS, SaaS一样，成为连接领域的通用规范，“从技术到应用，最难以突破的，是应用场景。如何缓解不同场景下物联网碎片化应用的困扰，实现每一个垂直领域物联网的应用价值，CaaS会给出答案。”",
    p8: "CaaS物联应用",
    p9: "1. 以零售行业为例，目前零售门店普遍采用的固网宽带接入方式存在使用成本和管理成本高、报装不方便、物业垄断、线路端口资源缺乏等痛点。红茶移动通过把RedteaReady连接能力集成到CPE、DTU等设备中，为零售商提供基于eSIM技术的灵活蜂窝网络连接服务，以替代固网宽带接入方案，或提供备用网络。因为部署灵活，资源可动态调配，可帮助商家节省超过40%的宽带成本以及降低连锁网点连接管理的成本。",
    p10: "2. 在汽车领域，该方案可帮助车辆中有联网需求的各类设备（如：后视镜、中控台、T-Box、OBD等）在到达目的地后自动连接至当地运营商网络，实现跨地域、全时域连接，车辆设备在生产阶段无需关心其最终使用地区，无需面向全球每一个市场预先定制当地SIM卡，尤其适用于“一点生产、全球发货”的应用场景。",
    p11: "3. 在SIM卡时代，追踪领域的主要应用场景都是基于实物的资产追踪，而eSIM的出现，催生了活体资产追踪的发展，如赛鸽。赛鸽追踪器需要做成脚环固定在鸽子腿上，所以要求设备非常轻巧 ( 需小于4克才不影响比赛飞行），以及要求脚环在鸽子的整个飞行路径中保持随时联网在线，以标记鸽子的去向、位置，及停留时间等，RedteaReady方案可以将SIM的能力集成到设备里不占空间，同时引入网络冗余概念,  让设备在断网后迅速远程启动备用网络, 恢复网络连接,  有效满足这一场景的所有应用需求。车载Tracker对于车辆设备追踪的应用场景也是同样的原理，无论是跨境，还是同一国境内跨地域，如不能百分之百保证单一运营商的信号全覆盖，一旦车辆驶入覆盖盲区，该方案可确保切换到有信号覆盖的备用网络，从而保证无缝的连接体验，这是传统方案无法实现的。",
    p12: "4. 本届展会上，红茶移动还展出了POS机、翻译机、Mi-Fi等手持终端设备。红茶移动可为此类设备商提供可在任何地方即时使用的便携式设备连接方案，包括：覆盖全球的流量资源保障,设备上电即可自动获取初始网络,无需插入SIM卡或连接Wi-Fi也可远程连接可用网络资源,系统流量和用户流量分别计算等。",
    p13: "此外，RedteaReady通过和NB-IoT模组集成，还可广泛应用于公共事业领域，帮助其带来降低基础网络设施成本，减少安装成本，提高网络安装效率等直接效益。",
    p14: "红茶移动自2015年成立之初就开始了在手机国际漫游服务领域深耕细作，如今已处于行业领导者地位，为其积攒了从全球网络覆盖到eSIM实现整套方案的产品化经验，并逐渐运用到应用更为广泛的物联领域。在此次移动大会上，红茶移动除了继续携其应用于手机终端的国际漫游服务产品参展，还展出了内置红茶bootstrap eSIM方案的智能手表。",
  },
  article6: {
    title: "红茶移动针对谷歌Pixel3系列eSIM功能发布“RedteaGO’’APP",
    p1: "Redtea Mobile日前推出“RedteaGO”应用程序，为谷歌Pixel手机用户提供基于其eSIM功能的全球数据流量服务，适用的机型包括Pixel 3、3XL、3a和3a XL，",
    p111: "“RedteaGO”应用目前已经上架Google Play商店。",
    p112: "“RedteaGO”可能是世界上第一个针对Pixel 3系列手机eSIM功能推出服务的app，可实现全球超过100个国家和地区的网络覆盖！",
    p2: "“RedteaGO”这款非常简洁易用的app为新的Pixel3系列提供了多种电子eSIM卡，让用户通过在app界面上进行简单操作，即可在全球范围内按需灵活选择不同的蜂窝网络套餐，空中下载和激活eSIM码号资源，即买即用，到达目的地后自动连接至当地运营商网络，无需插入任何实体SIM卡也无需担心当地运营商是否支持eSIM。",
    p3: "Google最开始是在Pixel 2和Pixel 2 XL上实现eSIM了功能，但彼时该功能仅对Google Fi用户开放，2018年开始逐步将其应用于Pixel 3系列（3/3 XL / 3a / 3a XL）。现在不止是Google Fi的用户，所有Pixel 3系列的用户都可以简单通过下载“RedteaGO”app获直接获取基于eSIM的全球流量套餐。",
    p4: "资费上，RedteaGO在亚洲提供的覆盖广泛的流量，1GB30天的价格为9.99美元。在欧洲和北美洲的流量套餐为1GB30天12.99美元。此外，为了庆祝针对Pixel3系列的eSIM服务上线，目前所有在RedteaGO上预订和购买任何流量套餐的客户均可享受50％的折扣。",
    p5: "除了针对Pixel3用户的‘‘RedteaGO’’app，“RedteaGO”作为红茶移动（Redtea Mobile）的子品牌，以手机终端为导向，在产品设计中充分考虑多元化的技术手段和实现方式，已经为多家OEM厂商的手机品牌提供基于eSIM技术的国际漫游服务。以确保各种智能手机用户都能轻松享受全球蜂窝数据覆盖，成为最终受益者。用户在不同蜂窝网络套餐之间切换，就像使用电视遥控器在不同频道之间切换一样简单。",
    p6: "我们的RedteaGO“全家桶”服务包括",
    p7: "1. 如果你是Pixel 3,3XL，3a，3a XL的用户，请下载“RedteaGO”APP。",
    p8: "2. 如果你是iPhone XS，XS Max和XR的用户，请访问RedteaGO eSIM网站。只需简单地扫描QR码即可通过无线方式激活eSIM。",
    p9: "3. 而如果你是Android手机，RedteaGO同样适用于当前较流行的Android手机机型：内置RedteaGO服务的设备将基于所处的位置，自动创建虚拟的当地SIM卡。它为您的海外旅行和商务出行提供方便快捷的数据网络服务。无需物理SIM卡，只需点击几下，即可激活并享受全球移动网络服务。这项服务自2015年开始在中国范围内广泛应用，目前RedteaGO已部署在大部分的智能手机上，包括OnePlus，OPPO，vivo，XIAOMI，联想，三星中国和hmd（诺基亚）等。随着OnePlus，OPPO和vivo推出的新智能手机出海，RedteaGO的服务也已在其他亚洲国家如泰国推出，自2017年以来马来西亚，印度尼西亚，印度和菲律宾以及美国和欧洲市场也开始不断有了“RedteaGO”的用户。",
    p10: "4. 如果你不属于上述任何一种，还可以购买RedteaGOSIM卡：虽然仍以可插拔式实体SIM卡形态存在，RedteaGO依靠远程SIM配置技术实现了一张卡承载全球网络的能力，为eSIM提供实践基础。该卡支持全球超过100个热门商旅国家和地区3G/4G流量上网，用户可根据行程灵活购买流量套餐，到达目的地后插卡即用，可重复使用。“RedteaGO全球无限流量卡”只提供海外经销代理服务。",
    p11: "详情请点击:",
    p12: "https://www.redteago.com/",
  },
  article7: {
    title: "针对支持eSIM的iPhone，Redtea Mobile将推出eSIM+平台",
    p1: "中国北京，2018年12月10日（GLOBE NEWSWIRE） - 来自NEWMEDIAWIRE  - ",
    p111: "领先的eSIM服务和设备连接解决方​​案提供商Redtea Mobile推出了一个名为esim.plus（eSIM+）的eSIM服务网站，这是第一个为支持eSIM的iphone提供流量套餐服务的平台。",
    p112: "该平台提供了一个开放的市场，支持MNO / MVNO快速eSIM解决方案部署，并为eSIM特色iPhone用户提供多种电子eSIM卡。",
    p2: "最新的iPhone对eSIM的支持开启了运营商和原始设备制造商的繁荣市场。包括Redtea Mobile在内的几家专业公司已经在利用Apple eSIM机会方面处于领先地位。",
    p3: "通过提供完全符合移动运营商GSMA标准的标准SIM配置平台（SM-DP+平台），eSIM +帮助他们快速部署适用于iPhone和其他eUICC终端的eSIM商用解决方案，实现运营商，特别是中小型运营商大型MNO和MVNO，在eSIM应用和跨境工作方面拥有公平的商机。",
    p4: "“eSIM +愿意为全球的MNO / MVNO引入新的eSIM商机，成为我们市场社区的一部分，从而为客户提供更广泛的eSIM卡选择和更大的eSIM服务选择自由。该平台允许最终用户现在，购买即付即用的本地连接以及现在覆盖60个国家和地区的多个蜂窝数据计划之间的切换非常方便，“Redtea Mobile发言人表示，并补充说eSIM是全球唯一支持消费者设备的远程SIM卡规范。",
    p5: "eSIM+首次推出了仅限数据的计划。在定价方面，它在亚洲提供广泛的覆盖，1GB 30天的价格为9.99美元。在欧洲和北美洲收购的eSIM计划的费率为1GB 30天，12.99美元。所有用户需要做的只是扫描QR码以通过无线方式激活eSIM，而不必担心他们的本地运营商是否支持eSIM。",
    p6: "预计未来将推出更多支持eSIM的手机，这将为客户提供极大的便利。作为运营商最开放的市场，几乎每个新iPhone用户都可以轻松选择，eSIM +真正有可能让业界惊叹并在社区中产生深远的影响。",
    p7: "作为领先的eSIM服务和设备连接解决方​​案提供商，Redtea Mobile提供全包式全球连接解决方​​案，包括全球蜂窝数据覆盖，完全符合GSMA eSIM标准的RSP平台，eSIM终端技术和基于eSIM的应用。 Redtea Mobile已与全球20家MNO / MVNO合作，覆盖90多个国家的3G / 4G网络。通过与众多知名手机品牌合作，Redtea Mobile已将其eSIM功能和数据/漫游服务交付给超过1亿台设备。",
  },
  article8: {
    title: "红茶移动荣获魅族2017年度最佳产品合作伙伴奖",
    p1: "2018年1月18日，以 All Win（共赢）为主题的2017魅族Flyme合作伙伴颁奖典礼在惠州隆重举行，活动邀请了魅族Flyme平台全球合作伙伴及智能技术行业各界精英。在颁奖典礼上，红茶移动荣获2017年度Flyme“最佳产品合作伙伴”奖项。",
    p2: "(红茶移动荣获魅族2017年度最佳产品合作伙伴奖)",
    p3: "2017年，红茶移动提供支持的手机漫游服务注册用户突破1000万。红茶移动凭借自身技术的先驱性和丰富的产品化经验，不断增强服务能力，各方位提升用户体验，在产品层面上与魅族Flyme也进一步提升了合作深度。",
    p4: "因此，红茶移动在本届魅族Flyme合作伙伴颁奖典礼荣获",
    p444: "“最佳产品合作伙伴奖”",
    p445: "。",
    p5: "(红茶移动荣获魅族最佳产品合作伙伴奖2)",
    p6: "自2015年伊始，红茶移动就连续荣获魅族Flyme肯定并授予奖项。",
    p7: "(红茶移动与魅族合作获奖历程)",
    p8: "目前，通过与全球20多家运营商/虚拟运营商合作，红茶移动的全球连接服务已覆盖超过90个国家和地区，并通过与魅族、OPPO、vivo、三星中国、小米、联想、nubia、乐视、锤子等知名品牌旗下的手机机型合作，红茶移动的eSIM能力及漫游服务触达逾1亿终端。",
    p9: "红茶移动历年获得奖项",
    p10: "在2017年，魅族Flyme厚积薄发，成绩斐然：截至2017年6月30日，Flyme注册用户量已突破6000万；应用分发能 力取得突破性增长，魅族应用商店总分发量突破300亿（实现从200亿到300亿的飞跃，仅用时10个月），2017年月平均分发量同比增长百分之六十 ；魅族Flyme主题美化平台月活跃用户3000万+，2017年下载量达到4.2亿次，比2016年增长了百分之七十五。",
    p11: "(红茶移动荣获魅族最佳产品合作伙伴奖3)",
  },
  article9: {
    title: "全中文解读GSMA最新报告《eSIM在中国：未来之路",
    p1: "本报告围绕以下几个方面就 eSIM 生态系统当前和未来的发展展开思考: 技术、用例、试行及商用、市场前景及挑战、政策及监管。报告先从全球视角出发,再聚焦中国市场进行分析。由于在用例、技术要求和商用时间上存在较大差异,我们把 eSIM 市场分成三大类来考虑其未来发展前景:消费类电子产品(可穿戴设备、平板电脑和笔记本)、智能手机和物联网 (IoT)。为完成报告和对研究作出必要补充,我们组织了深入的 eSIM 专题调研。调研集中在中国市场展开,主要向涉及更广泛的移动生态系统的中国企业以及在中国开展业务的国际公司征集意见和观点,包括运营商、SIM 卡供应商、设备制造商 (OEM)、物联网企业、科技公司和垂直行业机构。调研结果和各公司的观点在报告中得到整体体现。",
    p2: "eSIM 技术定义",
    p3: "在本报告中,我们使用术语 eSIM 指将 SIM 嵌入到设备的 SIM 卡以及相关的新生态系统。我们从技术角度使用以下定义:",
    p4: "通用集成电路卡 (UICC) 是移动设备中使用的硬件,它包含支持移动网络安全访问的 SIM、USIM 和 CSIM 应用程序。嵌入式 UICC (eUICC) 是指在设备生产过程中嵌入的 UICC。eUICC 技术可运用于任何 SIM 形式,包括嵌入和可插拔的 SIM 卡。",
    p5: "远程 SIM 卡配置支持远程下载并管理 eSIM 卡上所部署的配置文件,不必手动更换 eSIM 卡。此功能与硬件无关,也能在可插拔的 SIM 卡上部署。配置文件由和用户订购关系订阅相关的运营商数据组成,包括运营商鉴权数据及潜在运营商或第三方基于 SIM 卡的应用 - 与目前可插拔 SIM 卡上存储的数据基本相同。",
    p6: "嵌入式 SIM (eSIM)又称 eUICC,是支持远程配置的一种 SIM 卡形式。",
    p7: "GSMA 对以下公司提供的重要见解表示感谢:",
    p8: "奥迪",
    p9: "中国移动",
    p10: "中国电信",
    p11: "中国联通",
    p12: "中国-东盟信息港",
    p13: "金雅拓",
    p14: "捷德",
    p15: "果通",
    p16: "恒宝",
    p17: "慧与 (HPE)",
    p18: "",
    p19: "英飞凌",
    p20: "小天才",
    p21: "微软",
    p22: "出门问问",
    p23: "红茶移动",
    p24: "三星",
    p25: "树米科技",
    p26: "Valid",
    p27: "《eSIM在中国：未来之路》",
    p28: "目录",
    p29: "1) 概要 ",
    p30: "2) eSIM:全球局势",
    p31: "2.1 移动生态系统已经开始拥抱 eSIM 技术",
    p32: "2.2 在市场需求的推动下,eSIM 技术持续发展",
    p33: "3) eSIM 在中国:移动市场环境",
    p34: "3.1 中国移动生态系统四大趋势",
    p35: "3.2 eSIM 对中国移动生态系统演进的影响",
    p36: "4) 市场展望:中国 eSIM 前景",
    p37: "4.1 为 eSIM 生态系统的成长与发展奠定基础",
    p38: "4.2 消费电子:智能手表主导早期市场发展",
    p39: "4.3 智能手机:eSIM 有待商业推广 - 主流应用仍需时间",
    p40: "4.4 物联网:eSIM 应用空间巨大,汽车行业一路领先",
    p41: "5) 政策与监管:精简规则是推动 eSIM 在中国大规模发展的关键因素",
    p42: "6) 未来之路:整合生态系统,推动深入发展",
  },
  article10: {
    title: "重磅干货：全中文解读GSMA最新报告《2018全球移动趋势》",
    p1: "2018-2025年哪些因素在推动移动产业迈向2025年?红茶移动带你深度解析报告全文。",
    p2: "［申请原创保护］作者：明明眸、Vera",
    p3: "近日，GSMA智库（GSMA Intelligence）发布了《2018年全球移动趋势报告：哪些因素在推动移动产业前进?》。报告提供了海量的数据和对未来几年全球电信和移动产业发展方向的见解，概述了将在2025年之前塑造产业的五大趋势，分析了最新的移动互联网趋势、移动网络技术向5G时代的演变、物联网（IoT）增长的主要机会点、快速变化的媒体和内容市场，以及行业在重点区域的财务表现。红茶移动将带你深度解析这些趋势的主要内容。",
    p4: "此外，该报告还提供了全球各地区的最新数据点概览。",
    p5: "目录",
    p6: "第一部分：塑造电信产业的大趋势",
    p7: "第二部分：消费者与移动网络",
    p8: "第三部分：网络技术",
    p9: "第四部分：物联网(IoT)",
    p10: "第五部分：媒体与内容",
    p11: "第六部分：财务表现",
    p12: "趋势1: 下一代用户只用移动设备上网，将改变数字服务行业的游戏规则。",
    p13: "从现在起到2025年，全球将新增16亿移动互联网用户，大约一半新用户来自五个市场：中国、印度、印度尼西亚、尼日利亚和巴基斯坦。",
    p14: "中国和印度增长占比最大，印度尼西亚、尼日利亚和巴基斯坦的用户占比均超过5000万。",
    p15: "由于这些市场的固网宽带用户数量可忽略不计，下一代互联网用户将偏爱用移动设备、甚至可以说只会用移动设备上网。",
    p16: "研究如何利用移动端，为如此庞大且大多不讲英语的年轻用户群体提供服务（如：医疗保健、电子商务服务）十分重要。",
    p17: "2025年，36.92亿人将通过移动设备访问互联网，占全球网民的72%。移动＋PC用户将达13.18亿，纯PC用户仅6900万，拥有移动设备但是没有上网的人群为8.41亿，此外还有23.75亿人没有移动设备。",
    p18: "趋势2: 电信行业的5G与物联网市场机会更多依赖于企业，而非消费者。",
    p19: "从制造业到电力行业，5G和物联网的发展将创造新的机会以满足多种多样的企业需求。",
    p20: "企业将向边缘（包括超低延迟物联网、先进分析、AI、AR、VR、视频优化等技术；电信运营商提供移动2G／3G／4G／5G服务，云服务商提供PaaS服务。）推动竞争升级。服务可能会托管在运营商自己的网络内（私有硬件），硬件也可能由第三方云提供商（公共硬件）拥有，并由它们运营",
    p21: "电信运营商与亚马逊AWS、微软、IBM等云服务提供商既是盟友又是对手。一方面，他们通过低延迟物联网、分析技术争夺企业客户; 另一方面，为了扩大容量，它们需要进行合作或服务外包。",
    p22: "2017年的一份调查显示，69％的企业家认为一旦5G来临，企业服务会是最重要的营收来源。企业连接在物联网连接中所占比重将从2018年的41％攀升至2025年的55％。",
    p23: "趋势3: 连接技术商品化趋势明显，将在平台与分析层面创造更多价值。",
    p24: "连接仍然处于重要位置，但并非主要的价值驱动因素，尤其是在对延时不那么敏感的物联网应用场景（如智能抄表）中。",
    p25: "对于运营商而言，值得思考：物联网和5G服务是只作为“连接“服务来提供（低价值）？还是作为服务的一部分，加入分析服务作为一个整体来打包提供（高价值）？",
    p26: "或者也可以将高级连接作为锚服务提供，但是不独立于整体服务方案单独定价。无论如何，这种“站在客户立场思考”的思维方式与现成地销售技术一样重要。",
    p27: "2010年，连接的市场规模为110亿美元，约占物联网全球总营收的20％，专业服务市场规模120亿美元，比连接的份额稍高，应用、平台和服务市场营收250亿美元，占比超过50％。到了2025年，连接市场会达到510亿美元，份额降到5％左右；专业服务市场达到2990亿美元，占比接近30%；而应用、平台和服务市场达到7540亿美元，占比接近70％。",
    p28: "趋势4: 对于大部分电信运营商来说，对内容产业实行轻资产战略更具现实性。",
    p29: "内容为王，但价格昂贵。Netflix在2017年花费了63亿美元用于原创节目，与时代华纳（80亿美元）、福克斯（80亿美元）和迪士尼（78亿美元）相差不远。Netflix仍然是流媒体增长的最大驱动力，它继续蚕食传统电视收视和受众。对于大多数运营商而言，这种趋势意味着合作和许可内容比在昂贵的市场中获取或创建内容更具现实性。",
    p30: "趋势5:在物联网和5G的收益流得到证实之前，电信行业的整体收入趋于保守。",
    p31: "2017－2025年之间，工业物联网设备连接数将增长100.75亿，消费物联网连接将会增长60.49亿，授权低功耗广域网（LPWA）连接将增长18.28亿；3G连接减少1.38亿，4G连接增长25.70亿，5G连接增长13.56亿。2017年全球移动收入超过10,500亿美元，到2050年将会突破11,500亿美元。4G和5G连接继续增长, 但在这些新领域解锁新的收入来源之前，收入前景并不明朗。2020-2025年之间，收入增长率将会放缓保持在1%左右。",
  },
  article11: {
    title:
      "Counterpoint报告指出： 搭载eSIM能力的设备，预计将于2025年达到20亿出货量",
    p1: "智能手机，企业IoT设备以及可穿戴设备是eSIM应用爆发的主要领域，在2025年之前，就eSIM形态而言，基于硬件的eSIM方案的应用范围会是最广的，位居其次的是集成式eSIM和iSIM方案应用率。",
    p2: "首尔，香港，新德里，北京，伦敦，布宜诺斯艾利斯，圣地亚哥",
    p3: "据Counterpoint ETO（Emerging Technology Opportunities不断涌现的技术机会点）报道，基于eSIM的设备出货量将在2025年达到将近20亿，这个数字在2018年是3.64亿，增长的主要机会点来自于智能手机和企业IoT设备领域。 经过我们的研究发现，（到2025年，一大部分植入了eSIM能力的设备仍然将采用eUICC方案，接下来，搭载在SIM卡上的集成式eSIM方案将大幅增长。）",
    p4: "Counterpoint 研究分析师Satyajit Sinh在解析eSIM市场需求时表示，eSIM的应用增长将会颠覆整个行业设备激活和管理的方式，相比传统SIM卡的解决方案，eSIM带来的物理形态的变化将会为设备厂商节省很大的空间，同时提高安全性， 可编程性，以及续航效率。 对于运营商来说，eSIM可以极大减少SIM卡的分发和激活成本，同时有机会产生更高的漫游服务收益。 更重要的是，eSIM可以让消费者和企业客户享受到一整套无缝连接服务，包括自主灵活选择运营商，激活，连接，设备管理等服务。",
    p5: "Sinha补充到：“当前的eSIM方案可以多种形式存在，包括符合GSMA标准的搭载在硬件芯片上的eSIM方案和私有平台的方案，当前大部分eSIM方案的部署都是采用私有平台服务商的方案，然而，由于Apple,车联网厂商和可穿戴市场的eSIM应用，市场份额正在不断偏向GSMA标准eSIM方案应用，市面上这类方案的供应商主要包括英飞凌，意法半导体, 金雅拓，捷德, Workz等，而私有平台eSIM方案服务提供商主要有红茶移动, Truephone, Telna, ARM, 果通等。",
    p6: "图示1: 全球搭载eSIM能力的设备出货量 2018 vs. 2025的百分比增长",
    p7: "来源： counterpoint 研究报告 - 全球eSIM的定位追踪和预测- 2018 - 2025",
    p8: "包括eSIM所有形态 - 硬件形态，软件/虚拟形态以及集成式形态？",
    p9: "而关于eSIM的渗透应用的部分，Neil Shah 研究院表示，汽车和企业物联网设备将在未来的eSIM应用渗透率曲线中保持较高点的位置。而且eSIM激活率来看，企业级物联网设备会远远高于消费者IoT终端。这种现象产生的主要原因在于，设备连接部署的碎片化，模组空间不断缩小，不断增强的防篡改的安全性要求等挑战，以及eSIM带来的益处： 可选区域内轻易获得优质蜂窝网络，并且还能大幅提升实际部署和不断降低运维成本。",
    p10: "eSIM在智能手机上的应用将成为eSIM大规模商用的主要推动力量，目前的应用成果主要得益于手机厂商如Apple, Google对eSIM的积极部署，其他连接设备如移动热点设备，路由器，互联网电脑，无人机，以及智能手表的eSIM应用，因为当前应用的范围相对较小，都将呈现更高的年复合增长率。 然而，就出货量而言，智能手机和B2B 的物联网设备仍将排在前列。",
    p11: "Shah还补充到，过去的四年，在Apple和Google采用GSMA标准的eSIM方案之前，eSIM在智能手机上早先的应用一直是私有平台的软件形态的eSIM方案，这其中大部分实现商用的是中国的设备厂商。然而，我们看到在未来的5到6年，会有越来越多集成SIM和iUICC封装在SoCs内，不断应用在不同设备种类上，从而代替相对安全级别较低的软件形态eSIM方案。而硬件芯片形式的eUICC方案会在智能手机，车联网等领域广泛应用， 我们也相信iSIM或iUICC会在整个IoT应用领域得到大规模应用。",
    p12: "图示2. 全球搭载eSIM能力的设备出货量年复合增长率 2018 - 2015百分比",
    p13: "来源：Counterpoint 研究 - 全球eSIM跟踪和预测 - 2014 - 2025",
    p14: "包括所有eSIM形态 - 硬件形态，软件/虚拟形态，集成形态",
    p15: "",
  },
  article12: {
    title: "无所不在的连接为何至关重要",
    p1: "作者：Francesco Venturini, 埃森哲全球通信与媒介行业总经理（Global Industry Managing Director for Communications & Media, Accenture）",
    p2: "在过去的几个月甚至几年中，商业领袖们对通信行业现状与未来的担忧已经成为一种常态。为了保持领先与繁荣，一批具有前瞻思维的服务商已经开始对未来进行战略投资。很多企业将面向消费者(2C) 的业务作为其市场战略，而另一个有获胜机会的选择则是尚待开发的企业 (2B) 市场。",
    p3: "如果通信服务提供商（Communications Service Provider, 后称CSP）可以成为我们所称为的“连接领域的指挥官”，则有机会获得基于“泛在网络(pervasive network)”和“嵌入式连接(embedded connectivity)”的新一轮增长。",
    p4: "接下来我会做详细解释。各类型的商业正快速迈向数字化和互联化，随着5G技术变革带来的新的商业模式和服务，这一步伐将继续加快。",
    p5: "各类业务对海量数据实时分析需求的不断增长，基于软件管理控制节点和应用的传感器对系统采集数据的低延迟有较高要求，这为CSP类型的企业带来了积极发展“泛在网络(pervasive network)”和“背景感知网络(context-aware network)”的机遇，这种类型的网络通过构建支持微服务的通用API架构，结合嵌入式智能，为“数据流量”和“连接”成为可以交易的商品铺平道路，并催生“流量货币化”的新型商业模式。",
    p6: "服务提供商纷纷开始采用API作为其IT架构的基础组件，有很多还签署了《TM Forum Open API宣言》(TM Forum Open APIs manifesto)。但要成功实现商用，CSP还需要向企业市场提供一套新的、或者说扩展的实时网络能力，在适当的时间和地点满足企业级应用的需求，包括：网络切片能够满足动态连接、可以实现按需连接、具备移动边缘计算能力，或安全交易可追踪化等。",
    p7: "以上网络能力可以满足不同垂直领域的企业级应用需求。",
    p777: "举一个可以清晰展示其在制造业领域具有应用价值的例子。工厂的工程师们利用5G网络的低延迟特性，已经可以通过远程控制（触感技术）或增强现实技术(AR)进行关键干预决策或过程改进，并直接进行数据的现场分析。",
    p8: "例如，发动机或其他机械叶片出厂后被安装在装有传感器的车辆中运行，大量数据的采集和上传需要花费高昂的成本。而泛在网络的出现可以支持数据的分析处理在工业现场的边缘侧进行，大幅降低关键业务信息的传输成本。",
    p9: "接下来，基于这些分析结论，又可以从根本上提高生产效率，帮助发动机的设计或功能改进。 CSP可以为企业需要联网的设备实体或进程提供最佳的无处不在的连接服务，即一整套基于供应链的连接服务，并配合针对企业个体设计定制商用方案。",
    p10: "此外，通过提供供应链连接服务，CSP可以了解联网设备的使用背景，利用获取到的数据，结合认知智能和人工智能，创建一个更有效的平台来支撑业务进程。不仅如此，这些信息还可以在包括保险、区块链或产品生命周期管理伙伴等在内的更广泛的生态内进行交易。",
    p11: "这类服务将帮助CSP升级定位，成为可以整合和打通通信、IT数据分析，和实体设备，赋能工业物联网的现代化新兴企业，在Industry X.0时代成为主导角色。",
    p12: "另一个例子来自汽车行业。许多保险公司正在引入“基于使用情况付费”的收费模式，可以根据不同车型使用网络服务的时间、地点、距离和行为实行独立计费。CSP大可趁此机会亮出王牌，在提供业务数据分析平台和网络接入服务等方面寻求合作，稳固自身在行业中的角色和价值。",
    p13: "这些应用案例还只是5G时代很多新玩法的开始。对于CSP而言，同时兼顾本国网络覆盖的有效性和全球网络覆盖的广泛性，有效实现全球网络覆盖的规模化，才能真正发挥出他们对于数字化企业、生态合作伙伴以及最终用户的商业价值。如果哪家服务商能够成功地做到以上所有，势必能够在这个还有很大渗透空间的市场中推动新的增长，前景充满光明",
    p14: "编者按：在整个工业界面临着物联网化产业升级的大背景下，如何以连接为出发点，把工业供应链各个环节的业务逻辑有效的组织串联起来，是连接服务提供商应该思考的方向。红茶移动从云计算的角度来看待连接在通信行业的价值和机会。如同IaaS、PaaS、SaaS成为了云计算时代的三种主要服务范式(paradigm)一样，当通信从mobile based 或者 PC based 转移到M2M based，我们相信CaaS (连接即服务，Connectivity as a Service) 将会成为下一个服务范式，其推动力量包括:",
    p15: "1). 虚拟化：如何在各种各样的碎片环境下，实现SIM卡形态的虚拟化；",
    p16: "2). 抽象化：如何把软硬件系统、蜂窝网络覆盖、设备所处环境等一系列具体琐碎的复杂问题，转化为简单抽象的统一接口，向联网设备提供稳定的连接服务，比如：让设备”插电即可连接(Plug&Play Connectvity)”, 并“保持在线 (Always-on Connectivity)” ; ",
    p17: "3). 开放化： 让广大设备制造商和第三方开发者可以通过开放接口快速使用我们的连接服务，实现对网络套餐、网络服务质量(QoS)等连接服务的可编程。",
    p18: "从技术到应用，最难以突破的，是应用场景。如何缓解不同场景下物联网碎片化应用的困扰，实现每一个垂直领域里物联网的应用价值， 是红茶移动正在持续投入的工作。相比传统的通信市场，物联网市场用户的需求千差万别，技术能力参差不齐，这就让传统标准化的产品不能满足所有用户的个性化需求，从运营商网络到终端连接应用之间的最后一公里正成为物联网发展的最大制约。只有定制化的、多样化的一站式物联网解决方案才能支持用户个性化需求，打通物联网应用最后一公里。",
    p19: "（制造领域，基于连接的“流量货币化”案例）",
    p20: "（汽车领域，基于连接的“流量货币化”案例）",
  },
  article13: {
    title: "物联网世界的中枢神经",
    p1: "物联网世界的中枢神经：以eSIM技术为突破口的智能设备连接服务",
    p2: "近两年，全球有关物联网产业的大动作令人应接不暇：2016年7月，软银孙正义以310亿美元溢价收购英国芯片巨头ARM，他认为单ARM一家公司，未来20年的物联网芯片发货量就会超过1万亿；同年10月，高通收购全球车载芯片商恩智浦（NXP），以推动自己在物联网和汽车电子领域占据主导地位；2018年3月，阿里巴巴在云栖大会·深圳峰会上宣布将进军物联网领域，5年要连接100亿台设备；根据GSMA预测，2020年全球移动互联设备将达到105亿台，远远超过全球人口总数。",
    p3: "随着物联网（The Internet of Things, IoT）成为炙手可热的名字，eSIM也获得了越来越多的关注。同时，得益于Apple Watch 3, Google Fi，以及OPPO、vivo、小米等品牌手机厂商国际上网功能的推出，eSIM成为消费电子领域的潮流新宠。数以亿计的智能终端连接刚需，让eSIM逐渐从信息通信领域走进大众的视野。",
    p4: "一、风来了：从十亿级用量的SIM卡到百亿级终端连接的eSIM",
    p5: "如果说SIM卡是过去20年 “人联网” 的移动互联时代的产物，那么，eSIM则是为万物互联时代量身打造的新伴侣。",
    p6: "eSIM即嵌入式SIM（embedded SIM）的缩写，它将SIM卡能力集成到各种物联网芯片之上，用户不必再反复插拔SIM卡，而是以软件交互的方式，就可以在全球范围内将终端智能设备连接到所需网络，以使其可以始终处于高速的网速和覆盖。简单概括：①.它是跟终端设备集成在一起的 SIM 卡；②.它可以支持码号远程管理服务。",
    p7: "众所周知，传统SIM卡与终端设备是通过物理插入的方式进行结合的，并且需要与单一运营商的网络绑定，如果更换运营商网络，就需要从新的运营商那里取得SIM卡然后进行重新拔插。其弊端将随着物联网产业的大规模商用愈发凸显。",
    p8: "以车辆为例，首先，传统插拔卡在路况颠簸或车辆发生碰撞的情况下可能松动，不能保证后台可以进行稳定的通信, eSIM作为嵌入式集成芯片可以解决这个问题；再有，车辆通常需要出口到世界各地，车厂需要事先预估每个市场的出货量，如果预置单一运营商网络的SIM卡，一旦需要调货，整个流程会相当复杂，eSIM的码号远程管理能力可以解决这个问题，而且作为一个小元件，成本对于整辆车来说是微乎其微的；第三，车辆行驶的范围很广，即便在同一个国家，也存在不同运营商在不同区域网络覆盖信号强弱各有优劣的情况，SIM卡如果遇到某家运营商无信号而无备选网络，会影响车辆位置等设备信息回传，eSIM可以解决这个问题。",
    p9: "另外，有些物联网设备需要常年在野外运行，遭受日晒雨淋、偏高温或低温等恶劣的外部环境，还有些设备，比如光伏设备，生命周期比SIM卡本身的生命周期要长。eSIM不占空间、无需换卡、高安防、可远程管理码号资源等特性，在技术上有着SIM卡无法比拟的优势。未来，在如此海量的联网设备中，起到设备识别和连接作用的芯片将不再是SIM卡，而是eSIM。",
    p10: "二、从SIM到eSIM： 激发体系碰撞新机遇",
    p11: "首先从物理形态上，eSIM可以使卡槽消失，让设备拥有更轻薄的机身，在硬件设备工艺上对终端厂商更具吸引力。再者，其可远程无线管理码号资源的能力，可以使得原来得很多受制约应用与服务更加灵活，业务开展更具备可持续性；第三，由eSIM技术带动的物联网产业的发展，为运营商和通信领域带来了新的增量市场，带动了流量经营和创收的增长机会。",
    p12: "我们看到的趋势是通讯市场、终端市场、以及互联网之间的领域界限越来越模糊，运营商、硬件厂商和OTT之间涌现出更多的跨界联合，从谷歌斥资11亿美元收购HTC Pixel团队以扩大其在消费级硬件中的优势，到中国联通联合腾讯推出互联网SIM卡“王卡”，对腾讯体系内app提供免费流量，以通讯流量带用户流量，这些有趣的案例让我们看到整个业态越来越联合，合作越来越开放和多元，当然用户也从中受益。",
    p13: "三大运营商也越来越对eSIM持拥抱态度，并纷纷有所动作。中国移动率先推出“4G+eSIM”芯片，中国联通推出“eSIM产业合作联盟”计划，在其联盟的首批成员名单里，既涵盖了BAT在内的OTT，以及各大OEM厂商，还出现了SIM卡商、芯片和模组厂商，以及以红茶移动、果通为代表的连接解决方案提供商的身影，因为在这个跨界与联合的移动体系中，用户流量意味着价值，而连接能力意味着用户流量。",
    p14: "三、设备连接服务提供商的价值： 实现低成本、效率高的一站式连接能力分发",
    p15: "物联网产业市场很大，值得关注的是技术和应用碎片化现象还很严重，如何提升物联网连接的规模化效应是一个巨大挑战，也是一个绝大的机会。目前，物联网设备厂商需要花精力分别采购模组 、采购SIM卡、经营流量，如果额外增加eSIM的集成环节，无论是对设备成本，还是现有的产线和产能都会产生影响。这也是为什么终端向eSIM转型动力不足的原因。",
    p16: "因此，作为第三方设备连接服提供商所存在的价值，应该是作为网络运营商和终端设备之间的黏合剂，提供从网络流量、硬件、系统集成到服务的综合解决方案，打通设备连接的上下游。低成本、高稳定性、高集成度的“一站式”方案，甚至是“闭环式”方案，可以帮助智能设备厂商提高生产效率，让他们无需再跟进实现连接的每一个环节，也不必为繁琐复杂的实现方式操心，这样才能尽快推动物联网的规模化普及。",
    p17: "以红茶移动为例，从2015年开始，通过为手机品牌商提供国际流量服务占领手机国漫市场以来，其将在国漫市场所积累的上游运营商流量资源和产品运营经验，结合自身的eSIM连接技术，以“智能设备连接服务提供商“的姿态进入物联网领域，专注低成本、效率高的一站式连接能力分发。",
    p18: "四、物联网与eSIM的未来：连接即服务 (CaaS）",
    p19: "如何实现低成本、高效率的连接能力分发？",
    p20: "与云计算中SaaS (Software as a Service) 和 Paas (Platform as a Service）的概念类似，针对物联网和移动终端，红茶移动极具前瞻性的提出了”CaaS (Connectivity as a Service)－ 连接即服务”的概念。其核心要素是把连接和与连接有关的能力做作为基础效能 (Utility) 服务，通过标准接口开放给智能设备及第三方开发者。实现这个概念的第一步，是与芯片及模组厂商建立深度合作关系，早在去年，红茶移动就联合全球芯片巨头高通推出了基于iUICC的eSIM示范产品。",
    p21: "今年，红茶移动又在业内首推RedteaReady服务，通过与主流物联网模组制造商合作，将所有与数据网络连接有关的基础效能封装成符合eSIM标准通讯协议的服务，集成到物联网模组中，设备商只需采用已集成RedteaReady服务的eSIM模组，即可轻松获取数据网络连接，实现随时随地联网，并且可以通过用户后台实时查看和管理所拥有的设备及订单。此服务广泛面向车联网（智能后视镜、ODB、车载无线热点设备）、翻译机、Mi-Fi、智能耳机、智能抄表、Tracker、DTU、共享单车、广告机、视频监控等应用场景，以缓解不同领域物联网“碎片化应用”的困扰。",
    p22: "同时，这样一来，通过和硬件模组进行捆绑销售的方式，还可以改变当前模组厂商硬件硬件的单一业务模式，为他们创造基于流量经营和创收的能力。",
    p23: "CaaS的发想空间还远不止于此，比如，基于红茶移动提供的连接模块 (软件或硬件模组) 和标准接口，第三方开发者未来可以自主选择使用哪家运营商资源提供数据服务，网络质量、网络延迟性等各方面的要求也可以自定义，还可以在设备默认的运营商资源信号不好或不可用时，切换到其它可用的运营商资源。通过标准服务的形式，CaaS可以给开发者更多关于连接管理的自主性和灵活性，以实现插电即连接 (Plug&Play Connectivity) 和保持在线 (Always-on Connectivity)。",
    p24: "在这个万物互联的伟大时代，做点有趣又有意义的事情，一切才刚开始。",
    p25: "本文首发于亚太MVNO产业联盟",
  },
  article14: {
    title: "苹果持续发力推动，eSIM应用将迎来大爆发",
    p1: "今年三月，带有eSIM功能的 iWatch Series 3 初次加入了LTE数据连接功能，使得它可以独立进行操作，不用连接iPhone就可以直接拨打电话。这两天热议的苹果发布会，其中引人关注的焦点，就是苹果在新手机中支持了eSIM, 苹果不但再一次引发了业界对eSIM的热议，也帮助eSIM走进了消费大众的视野，呈现一片燎原之势。",
    p2: "如今，点开知乎、悟空问答等各类热门问答平台、知识社区，无一不在讨论eSIM将会带来的影响。乐观的说，eSIM的推广已无人可阻，呈燎原之势。苹果的举措也将对引导市场，推动未来整个终端产业链的升级产生重要意义。",
    p3: "如论坛笔者提到的，中国主流安卓手机品牌的双卡双待功能早已成为标配，并已纷纷推出国际上网功能，打响占领备用卡槽的战役，这项功能主要是通过eSIM技术实现空中入网来实现，为用户提供海外移动数据服务，用户通过这些手机品牌自带的app, 即可选择想要去的国家或地区，购买适合自己的流量包套餐，用户到当地后开通服务，不用插拔更换物理SIM卡，服务器就会把相应的当地运营商资源空中下发至用户的手机终端实现连网，简单方便，便宜好用。",
    p4: "继天际通之后，各家手机品牌推出的产品包括：OPPO“国际上网”，vivo“i漫游”，小米“小米漫游”，OnePlus“全球上网”，与其合作的服务提供商均为红茶移动。除此之外，在三星（中国）、魅族、锤子、联想、nubia、诺基亚、糖果、海信等手机品牌推出的类似服务中，也都发现了红茶移动作为服务提供商的身影。细了解这家企业，原来这家科技公司早就是从2015年开始就为多家国产安卓手机品牌提供eSIM国际漫游服务的老司机了。",
    p5: "红茶移动现在已经为十多个主流安卓手机品牌提供境外网络服务，覆盖2亿终端设备。",
    p6: "可以空中远程对设备进行SIM卡的文件配置，是实现eSIM的关键。简单来讲，它是将传统SIM卡直接嵌入到设备芯片上，然后通过动态更换和写入运营商数据的方式来实现传统SIM卡的功能。对于用户来讲，不需要弹出卡托更换SIM卡，就可以在不同运营商网络间自由切换，就像拿着电视遥控器更换频道一样方便。今天我以红茶移动作为案例，来盘点一下基于eSIM黑科技在手机上的新功能。",
    p7: "1. 专属流量套餐",
    p8: "又叫定向流量包，其特点为不依赖运营商网络，可就特定的几款程序单独开启专属流量包，打造不同种类的专属流量包，以满足不同人群的需求，比如：出境游常用app套餐专属流量包、游戏专属流量包、直播专属流量包等专属套餐。",
    p9: "2. “无网购买”服务",
    p10: "可以让用户在落地境外后，无网络的情况下购买红茶移动内置于手机上的漫游服务，连接到该地区的服务器（如下图），进而用户可以购买自己所处目的地国家或地区的流量套餐，并开通启用。",
    p11: "3. 无卡无网手机找回功能",
    p12: "即使用户的手机SIM卡被拔掉，连接不到移动蜂窝数据，也不处于Wi-Fi环境中，但只要手机开启了【查找手机】，自动监测到手机异常操作的行为，就会触发搜寻全球网络资源去强制联网，无论天涯海角，保证用户的手机不失联。",
    p13: "eSIM的玩法很多，但eSIM的推广普及有赖于运营商的支持，此次全球几大主流运营商都加入为苹果eSIM站台之列。",
    p14: "苹果官网公布支持eSIM的运营商名单",
    p15: "此外，2018年6月7日，泰国运营商TrueMoveH首推eSIM卡连接智能手表；6月10日，日本运营商KDDI宣布与丰田合作，推出eSIM卡连接汽车；6月13日，匈牙利运营商Magyar Telekom首推eSIM卡，智能手表成为兼容该eSIM卡的设备先驱者",
    p16: "再看国内市场，2018年3月7日，中国联通率先在上海、天津、广州、深圳、郑州、长沙6座城市启动“eSIM一号双终端”业务。4月6日，中国联通聚合OTT，OEM厂商，芯片模组厂商、SIM卡、eSIM技术服务提供商等产业各方力量，成立“eSIM产业合作联盟”（红茶移动有幸成为联盟首批成员），打造eSIM全智能体系。另外在5月25日，中国移动旗下子公司中移物联正式推出智能物联China Mobile Inside计划，同时发布国内先驱eSIM芯片，提供“芯片+eSIM+连接服务”；6月1日，中国移动在天津、上海、南京、杭州、广州、深圳、成都7个城市正式启动“eSIM一号双终端”业务。",
    p17: "eSIM应用正在不断扩展，不要忘了，eSIM还面向一个更大的连接市场——物联网。由于空间、环境等限制，传统需频繁更换的SIM卡无法适应大规模物联网部署。",
    p18: "eSIM卡不是要革运营商的命，而是为运营商带来新的增长点。物联网是eSIM的海量市场，也是运营商的未来市场。从人与家庭的连接到万物连接，从消费者领域向垂直领域扩展，这是运营商目前正迈进的大幅跨越。说直白点，人和家庭的连接已经到头了，人口红利没了，市场饱和了，万物互联才是运营商的下一个爆发的增长点。",
    p19: "据了解，运营商、芯片和模组厂商、卡商、设备制作商，以及以红茶移动为代表的方案商，都已经开始在物联网方面有所布局和发力。伴随着eSIM规范和技术的不断成熟，以及更多运营商的开放支持，如果苹果公司通过支持eSIM的手机成功打入了市场，以其体量和影响力将会推动eSIM技术的大规模应用，eSIM不仅在消费电子领域具有重大的意义，还将推动物联网的迅速发展，具有极大的想象空间。",
  },
  article15: {
    title: "5G来临！物联网的世界你确定不要了解一下？",
    p1: "中国联通5G论坛演讲：浅析eSIM在消费物联网领域的应用创新。",
    p2: "首先，简单科普一下让我们耳熟能详但又不明觉厉的5G、eSIM、 物联网 (IoT) 之间，到底是什么关系？",
    p3: "5G和4G:",
    p333: "5G和4G的区别可不是“啊~啊~啊~5G，你比4G多1G” 那么简单，5G网络取得的技术性突破，不单止给消费者带来更快更流畅的上网体验，还可以解决传输速率以及庞大数据连接集合的问题，具备大宽带、低延时、广联接的场景特性。",
    p4: "5G和IoT:",
    p444: "以上场景特性正解决了物联网痛点。举个例子，在交通领域，4G网络由于网络传输速度较慢，有响应机制延迟的问题，如果以5G网络为基础，汽车可以与周围汽车、信号灯、建筑甚至道路实时交换数据，实现万物互联，助推无人驾驶技术的发展。",
    p5: "IoT和eSIM:",
    p555: "从原来十亿量级用量的 一人一卡“人联网”时代，到百亿级终端用量的”万物互联“时代，海量联网设备的识别和连接刚需旺盛，eSIM不占空间、无需换卡、高安全、可远程管理码号资源等特性，在物联网领域大有可为。",
    p6: "简而言之，5G是物联网生态系统的推动力，5G时代，物联网将成为eSIM应用的“网红”切入领域。",
    p7: "中国联通：迅速发布5G终端战略，未来两年投资210亿。",
    p8: "12月6日， 三大运营商5G频谱划分落定。",
    p9: "12月14日，中国联通在广州召开“2018网络技术大会终端论坛”，发布5G终端战略：将在导入期和快速发展期内整合100亿权益赋能、100亿金融赋能、10亿平台补贴，以保障其5G商用终端规模。",
    p10: "中国联通还在本次大会上发布了其网络侧的商用/试点进展及计划：将围绕京津冀、长三角、珠三角、直辖市及中部重点城市群，开展17个试点城市5G业务示范及网络试验工作。同时，揭牌成立 “5G行业终端联合创新实验室”，用以孵化融合相关创新应用和产品，形成中国联通5G生态核心能力。此外，本次大会还发布了面向开发者的eSIM终端测试环境帮助终端厂商自助完成联调测试，并成立eSIM终端联合测试平台，推出eSIM产业联盟合作网站。",
    p11: "未来，在万亿规模的设备连接中，起到设备识别和连接作用的芯片将不再是SIM卡，而是eSIM。 物联网产业虽然市场机会巨大，却仍然面临严重的技术和应用碎片化现状，面对“连接”和“可扩展性” 两大挑战，该如何提升物联网连接的规模化效应，抓住5G时代下的物联网机遇？",
    p12: "红茶移动作为中国联通eSIM产业合作联盟首批成员，其联合创始人兼CEO金辉博士受邀在 “网联万物，智胜未来” 中国联通5G终端与eSIM产业联盟论坛上发言，与同行交流“SM-DP+在消费物联网领域的应用和创新”。",
    p13: "划重点！关于物联网应用趋势的几点判断：",
    p14: "1.  以连接为切入点的云、管、端系统化服务将成为物联网服务的主流模式；",
    p15: "2.  基于应用的专网连接具有广大的市场空间；",
    p16: "3.  物联网应用需要下沉行业，解决多样性是关键",
    p20: "4.  服务中小企业存在巨大机会；",
    p21: "5.  边缘计算存在巨大应用场景；",
    p22: " CaaS（连接即服务）：云计算在物联网时代的新元素。",
    p23: "“与手机等消费电子设备可以由用户操作不同，很多物联网设备是无人值守的，没有交互界面，它们是‘被动’的，也不会‘投诉’，而且物联网终端和应用多样化，跨地域、跨运营商之间的互操作频繁“，金辉认为在网络与终端，在运营商与终端设备商之间还需要一个“最后一公里”粘合剂，物联网应用需要下沉行业来解决多样性的问题，可以整合“碎片”，统一“接口”，提供无缝的物联网连接，”尤其是很多中小型设备企业，自己不具备平台能力，他们非常需要这样的连接服务，这是红茶移动作为‘连接服务’技术供应商的核心价值“。",
    p24: "以连接为切入点的云、管、端系统化服务将成为物联网服务的主流模式。与当下热点的云服务架构Iaas, Pass, Saas类似，针对物联网和设备终端领域，红茶移动极具前瞻性的提出了“CaaS (Connectivity as a Service)-连接即服务”，其核心要素是把连接和与连接有关的能力做作为基础效能(Utility)服务，通过标准接口开放给智能设备及第三方开发者，让设备出厂就可以实现插“电即连接 (Plug & Play Connectivity)”，在运行过程中可以“保持在线 (Always-on Connectivity)”。",
    p25: "RedteaReady：拓展联通DP+服务支持广泛的M2M应用场景。",
    p26: "基于CaaS的概念，红茶移动以eSIM连接技术作为突破口，推出RedteaReady，把从网络流量、远程SIM配置、终端系统集成、连接服务管理平台，及相关配套服务等所有与数据网络连接相关的环节封装成统一服务，以更好支持联通SM-DP＋在M2M场景下的广泛应用。",
    p27: "中国联通一直积极为大规模物联网应用寻求领先的新型标准和创新技术，红茶移动基于中国联通SM-DP+的拓展服务，良好示范了数据网络连接在物联网模组上的无缝运行，既可有效满足与现有移动运营商基础架构的快速集成，支持运营商开拓新的流量分发增长点，同时可以帮助设备制造商提供更加完整和集成的解决方案，减少物理空间需求，提高单位成本效益，缓解不同场景下物联网碎片化应用的困扰。最终形成一个多赢的局面。”",
    p28: "应用案例：基于应用的专网连接市场－连锁商家联网新选择",
    p29: "目前实体门店普遍采用传统的固网宽带接入方案，该方案存在使用及管理成本高、报装不方便、线路资源缺乏等痛点。且随着门店数量的激增，给网络建设、日常运维，及连锁零售商家对其线下连锁门店的统一管理，带来了极大挑战。红茶移动联合国内领先的智能商业架构及运营服务提供商迈外迪推出网络智能硬件－云宽带，把基于eSIM技术的RedteaReady连接能力植入迈外迪网络硬件，为商家提供网络接入和组网方案，可灵活部署，插电即用，可根据网络环境差异确保设备始终在线，可帮助商家节省超过40%的宽带成本。此外，连锁门店可以通过总部统一申请，并统一在平台上进行设备和资源管理，管理成本也可大幅降低。此举将eSIM技术创新应用于新零售领域，为连锁门店解决实际困难，属行业首创。目前该应用已涵盖服装、运动、餐饮等多个领域的100多家连锁零售商。（了解案例详情，请参考文章：案例分享| 行业首创：红茶移动x迈外迪，将eSIM技术创新应用于新零售领域。",
    p30: "此外，连锁门店可以通过总部统一申请，并统一在平台上进行设备和资源管理，管理成本也可大幅降低。此举将eSIM技术创新应用于新零售领域，为连锁门店解决实际困难，属行业首创。",
    p31: "SM-DP+在消费物联网领域的应用和创新",
  },
  article16: {
    title: "#红茶人说－你眼中的eSIM",
    p1: '红茶移动相信“连接”的力量, 不仅是设备与设备的"连接", 也是人与人之间的"连接",用eSIM连接世界。',
    p2: "红茶移动eSIM方案受到越来越多用户和合作伙伴青睐, 很多同事最近出国到各地洽谈业务或做技术支持, 公司内部开了英语角, 来自各部门的小伙伴聚在一起, 就“eSIM带来兴奋的用户体验” 聊见闻, 谈想法, 从而更加理解公司, 客户和合作伙伴, 不断完善服务, 加深行业合作。",
    p3: "01. 品牌管理部",
    p4: '"红茶移动相信基于eSIM可以带来更多让用户兴奋的体验, 建立更加连接的未来"。',
    p5: "一切开始于一个纯粹的想法:红茶移动创始人最开始只是想做出一款“漫游”产品, 让用户可以全球上网的APP, 出国不用换SIM卡, 只需要花费跟当地居民一样的资费, 就可以自由的享受网络服务。这个产品可以搭载在SIM卡上, 也可以直接通过跟手机厂商合作, 作为手机的内嵌功能来实现, 改善人们的出行生活和沟通方式。",
    p6: "不断深入基于eSIM的设备连接,我们了解到，不仅在消费电子领域，其实在物联网领域，由于传统可插拔SIM卡难以完全满足M2M设备的工业级需求，市场空间非常广阔。",
    p7: "坚守自己的定位:基于eSIM“5G时代的设备连接专家”, 面向智能终端提供“连接”服务, 这里的“连接”指的是蜂窝网络连接, 包含2G/3G/4G, 和即将到来的5G。",
    p8: "基于初心，红茶移动目前做两件事儿：",
    p9: "1. RedteaGO: 消费电子全球上网服务",
    p10: "2. RedteaReady:可编程的海量物联网连接解决方案;不插卡，不换卡，无SIM卡通讯;无预支成本，自由订阅网络;连接及服务;插电及连接;保持在线。",
    p11: "02: 消费电子业务线",
    p12: '"逐渐地, 红茶移动"RedteaGO"成为大部分品牌手机内置漫游APP唯一选择"。',
    p13: "手机内置漫游APP",
    p14: "消费者全球流量服务",
    p15: "如果你有一部手机,eSIM可以实现:【不换卡不换号，当地资费，联网流畅】",
    p16: "以往出国对于流量的几个选择：1. 开通昂贵的国际漫游 2. 买当地运营商的卡, 买卡还需要换卡, 有些还要剪卡, 小卡不便于携带, 易弄丢 3.携带Mi-Fi等重量级设备。",
    p17: "现在有了eSIM方案，不用取卡，不用换卡，打开漫游app，购买相应目的地流量套餐，激活，即可。有些手机还未内嵌的，红茶移动通过二维码空中下发资源(暂时只支持部分海外苹果机型，具体请访问：https://www.redteago.com/ )。流量为当地资费成本, 而且断网了自动连接上，切换到最优网络资源，如果要用到流量的地方多，比如分享照片，查景点，搜民宿，探美食，eSIM状态下，联网快，流量费低，这时候的感觉，用一个词来形容体验: global 无障碍。",
    p18: "在未来，也许我们买了新手机不用再去营业厅买卡，这一点不止适用于手机，还适用于任何连接网络的智能设备（如智能手表），直接开机就有了SIM卡的所有功能，那是因为eSIM已经悄悄嵌入进去，给你惊喜。",
    p19: "03: 物联网业务线",
    p20: '"很快，红茶移动"RedteaReady" 将基于eSIM, 满足海量物联网连接需求, 共筑更加连接的物联网时代"。',
    p21: "如果你有一辆车,eSIM可以实现:【一直保持在线，一直畅享在途】",
    p22: "车联网即通过各种车内车外的智能设备, 将采集到的信息汇聚, 传输至网络端, 进行分析处理。简单来说，你前方是否堵塞，周围有多少车，车速如何，路面状况如何，车没有油或者没有电了，哪里有加油站, 这些你都了然于胸，淡定地在车内打开,在线音乐，在线新闻，网络电台等，而实现这一切功能的基础是: 联网！eSIM实现的全时域覆盖的优质网络，断网自动连接的特点, 赋予你流畅的一段车程。",
    p23: "而汽车联网的技术实现手段上，传统SIM卡常常无法满足远距离通信所要求的抗震防潮，低能耗等，并且在某些特定情况下，无法换卡或临时订阅新的运营商（比如断网的情况）eSIM可以解决以上问题，通过RedteaReady管理平台可远程操作网络连接管理，一直保持在线，一直畅享在途。",
    p24: "如果你有一个现代化的家,eSIM可以实现的是:【一键全控无难度, 你的智能基地】",
    p25: "“智能灯控, 智能门锁, 智能监控, 节能管理”, 现代人们越来越需要一套完整的方案将家里打造成智能基地, 市面上出现越来越多的自动化家居产品, 通过智能网关移动app控制, 将一部分任务自动化, 从而打造便利, 简单, 舒适的生活体验。eSIM嵌入智能网关, 即可一键掌控家中设备连接情况, 流量使用情况, 一键全控无难度。",
    p26: "04. 运营商开拓业务线",
    p27: '"因为eSIM, 我们和全球运营商一直保持深度合作, 并且提供全球流量服务"。',
    p28: "eSIM为运营商实现：",
    p29: "降低运营成本:针对使用eSIM的设备, 运营商不用再购买, 储存, 编码, 运输SIM卡, 售后服务流程大大简化, 降低流量运营成本, 并不断提高用户满意度。",
    p30: "增加更多用户:远程配置网络资源, 可以自由选择切换运营商, 将不同于传统长期合同绑定, 在任何时候同一覆盖区域可以通过网络资源的性能再获取更多用户的信赖，而不会流失太多长期绑定别家运营商的客户。",
    p31: "新的发展机会:整个eSIM生态系统对于设备连接的创新将有巨大的发展空间, 运营商作为生态链的上游, 网络资源提供方, 可以率先推行eSIM, 在生态链中发挥更大的价值。",
    p32: "05. 商务拓展部",
    p33: '"基于eSIM, 我们帮助越来越多设备, 抓住物联网时代的机遇"。',
    p34: "eSIM为设备商/芯片商/模组厂商实现：",
    p35: "于设备商: ",
    p36: "eSIM可以实现:【远程配置运营商资源，批量部署和管理网络连接】",
    p37: "大部分设备长期无人值守, 可插拔式芯片卡无法满足工业级环境温度湿度等严苛的要求, 而大部分IoT设备生命周期长无法轻易更换对外通讯的零部件, 并且在部署方面无法批量复制. ",
    p38: "红茶移动RedteaReady的eSIM方案可实现：一点生产, 全球发货, 拥有“ 保持在线, 插电即连接, 连接即服务”的核心优势, 连接服务包括远程配置资源, 可视化平台监测, 管理设备连接, 流量使用情况, 并且把eSIM软件实现的连接能力以API形式对外开放, 让设备商批量部署连接。",
    p39: "eSIM为芯片商/模组商实现【新的业务收入】",
    p40: "集成了eSIM能力的芯片, 将为芯片商/模组商带来更多新的机会（随着更多设备有了eSIM需求）而且基于eSIM方案, 可以让设备商简化流程, 省去制卡的流程, 出厂即可实现网络连接, 从而让芯片商在IoT时代的角色升级, 不再受限于单纯提供芯片的服务。",
    p41: "06. 研发部",
    p42: '"eSIM可以为开发者实现: 可编程的连接, 更专注于业务创新"。',
    p43: "1. 更专注业务逻辑",
    p44: "eSIM是软件形式实现的网络连接，其中CAAS概念由eSIM服务商红茶移动提出，并作为一项核心能力，提供对外的标准接口，开发者无需关注设备管理、网络连接、网络协议相关的逻辑，只需要调用对外的标准接口，最大的好处就是开发者可以略去上述技术流程，从而更专注于自己的业务场景、业务逻辑实现；",
    p45: "2. 利用可编程连接",
    p46: "可以利用红茶移动的 CaaS 能力和通道自定义和设备通信的指令, 进行指令收发、数据传输；",
    p47: "3. 管理简单",
    p48: "包括设备管理、连接管理、流量和网络管理",
    p49: "4. 更易适配云服务",
    p50: "CaaS 的连接能力也是安全、稳定、基于云的，可以用红茶移动的云平台，也可以接 aws 等第三方云，以自动适配和不断增长的业务需求同步的企业云服务架构",
    p51: "结语",
    p52: "“eSIM让人兴奋的用户体验” 将影响IoT全行业, 是网络连接的一种创新。",
    p53: "我们相信基于eSIM可以建立一个更加连接的世界, 通过促进运营商, 智能手机和设备厂商, 芯片/模组厂商的发展, 连接彼此, 从而推动全行业向前迈进。",
    p54: "科普一下:",
    p55: "eSIM技术",
    p56: "科普一下，eSIM的最大好处之一就是订阅运营商网络及其简单，买了设备之后，不用去排队买卡，等购买的卡到，直接在手机端切换网络，如果是无人值守的IoT设备，则后台自动切换，而且如果你将eSIM作为手机备用卡，eSIM的技术可以支持多个账户，并且自由切换及其简单。",
    p57: "“网络连接”的几点趋势",
    p58: "1. 蜂窝网络连接需求不断升级",
    p59: "一切智能设备都需要网络连接，到了物联网的时代，设备的网络连接需求升级，物联网应用不断出现，设备厂商希望设备保持在线，并且通过平台可以统一部署和管理。",
    p60: "2. 5G即将到来，催生物联网爆发",
    p61: "随着物联网用例的广泛推广、基于4G技术的物联网设备的持续部署和5G网络商用，以2G、3G和4G技术为主的技术结构将有望转变为以4G和5G技术为主的技术架构，从而推动物联网的快速发展，提升物联网连接的速率，实现终端智能设备的高效运转。",
    p62: "3. 作为5G时代发展的产物之一：",
    p63: "NB-IoT的低功耗，室内覆盖，低成本, 密集连接强度的特点将积极推动NB-IoT技术在智慧城市、智能建筑、智慧社区、智慧家庭、农业、物流、工业等更多场景的创新融合应用，提效降费，为更多产业赋能。",
  },
  article17: {
    title: "从「智能制造」到 「智能IoT」，连接是关键",
    p1: "(关于台湾区域，eSIM在“智能制造”的多元应用）2019年12月19日 | 台北 富邦金控会议中心 天气晴",
    p2: "在一场面向台湾工程师社群和台湾知名企业研发的盛会 —— “2019智慧制造暨趋势发展研讨会(EETimes IOT seminar)”上，红茶移动分享了针对性解决「智能IoT」的多重挑战的答案：连接即服务，并首次发布重塑LPWAN业态的创新方案RedteaSIM。",
    p3: "在5G商用背景出台以及工业4.0概念的推动下，作为通信领域IoT连接服务商，红茶移动以“设备连接”的创新为入口，借助5g高传输，低延迟与更广的覆盖范围的特性，提出连接即服务(CaaS, Connectivity-as-a-Service)，并与当地合作伙伴贝能国际联合展出 「连接可扩展的蜂窝网络连接应用」，共同推动「智慧制造」进入到下一个阶段:「智能IoT」。",
    p4: "（图为红茶移动执行副总裁杨晓庆发表主题演讲 “用CaaS迎接海量物联网连接）",
    p5: "关于大背景【 “智能制造” 到 “智能IoT”, 连接是关键】",
    p6: "智能制造对海量数据实时分析需求的不断增长，基于软件管理控制节点和应用的传感器对系统采集数据的低延迟有较高要求，网络服务需求开始升级，出现“泛在网络(pervasive network)”和“背景感知网络”等新的概念，即可以随时，随地，任何人，任何物接入网络，形成M2M连接，并且基于不同的背景感知，可调配按需的网络服务质量，这种类型的网络通过构建支持微服务的通用API架构，结合嵌入式智能，助力“智能制造”转向用于真正的“智能IoT”，关键环节在于“数据流量”和“连接”：",
    p7: "发动机或其他机械叶片出厂后，被安装在装有传感器的车辆中运行，大量数据的采集和上传需要花费高昂的成本。而泛在网络的出现，嵌入了RedteaReady模组带有“上电即连接” 和“保持在线”能力的传感器之间互相通信，并保障和设备连接管理平台随时随地通信，可保障数据的分析处理在工业现场的边缘侧进行，并可按照需求控制传输所需数据流量，大幅降低关键业务信息的传输成本，这一点尤其在大规模物联网部署，如工业网络环境下，将极大提高生产效率。",
    p8: "接下来，基于这些分析结论，又可以从根本上提高生产效率，帮助发动机的设计或功能改进。红茶移动可以为制造企业需要联网的设备实体或进程提供最佳的无处不在的连接服务，即一整套基于供应链的连接服务，并配合针对智能制造企业设计定制商用方案。",
    p9: "关于台湾市场【台湾区域，eSIM在“智能制造”的多元应用】",
    p10: "IDC、Gartner、McKinsey 等多家权威机构预测, 到 2020 年全球的物联网设备安装量将超过 200 亿, 整体物联网市场规模将超过3万亿美元。而物联网中的 M2M 领域为 eSIM 主要市场, ABI Research 也指出 2020 年 M2M 装置将达4.5亿。因此,eSIM 的出货量相对应會达到2亿张, 市场将迎來近 100% 的复合年化增长, 而传统SIM 市场将逐步萎缩。想想当然, 全球 M2M 市场极速的增长, 也反應到台湾 M2M 中的 eSIM 应用上, 依不同使用情境, eSIM 应用內容也有所不同,如下页图 2-1。",
    p11: "（图来源于物联网eSIM技术与应用白皮书-远传版）",
    p12: "以上垂直领域里物联网的应用场景各异，均有其个性化的需求，但又都属于物联网化产业升级的大背景下，基于“eSIM连接”的应用最好的实践案例，面对以下同样的挑战：",
    p13: "如何在各种各样的碎片环境下，适配多种操作系统和安全介质；",
    p14: "如何把软硬件系统、蜂窝网络覆盖、设备所处环境等一系列具体琐碎的复杂问题，转化为简单抽象的统一接口，向联网设备提供稳定的连接服务，比如：让设备”插电即可连接(Plug&Play Connectvity)”, 并“保持在线 (Always-on Connectivity)” ; ",
    p15: "如何通过开放接口快速使用红茶移动提供的连接服务，实现对网络套餐、网络服务质量(QoS)等连接服务的可编程。",
    p16: "CaaS【红茶移动CaaS，针对性解决「智能IoT」的多重挑战】",
    p17: "红茶移动执行副总裁表示： “作为连接服务商基于CaaS“连接即服务”的概念，借助“虚拟化”， “抽象化”，“开放化” 逐一解决以上大部分设备制造厂商，在规模化部署物联网的征程上所面临的一系列挑战。”",
    p18: '（CaaS: "连接即服务"三个技术能力突破点）',
    p19: "针对每一种场景均有其对应的产品/解决方案，比如面对“个人消费市场”的全球数据流量服务RedteaGO, 流量覆盖超过100多个国家，当地速率，当地资费。为Global情境下的设备厂商提供的RedteaReady服务，出厂即带网络连接能力，基于设备最终所到达的位置，上电即连接，灵活配置当地运营商资源，无需针对每家当地运营商定制SIM卡，免去和全球每家运营商协商的流程",
    p20: "RedteaSIM：新型SIM分发管理方案",
    p21: "针对“二次销售”和“单一国家输出”的大型机具，冷冻柜等LPWAN场景设计的RedteaSIM新型SIM分发服务，旨在提高SIM分发效率和生命管理周期，大大降低成本提高效率。本次大会上首次发布重塑LPWAN业态的创新方案，新型SIM分发管理方案RedteaSIM，将SIM直接集成于系统芯片 (SoC) 中，实现成本效益和分发效率的双重提升。",
    p22: "RedteaSIM是红茶移动面向运营商和设备商推出的一种创新的SIM分发管理方案，为低功耗广域物联网（包括NB和Cat-M1) 的蜂窝网络连接应用带来颠覆性的变革。通过与芯片厂商，模组厂商，设备厂商和运营商开展广泛合作，红茶移动推出的RedteaSIM方案，可实现将SIM功能直接集成在芯片上，空中下发，在设备生产过程中即预置运营商资源，从而降低集成复杂度。RedteaSIM旨在推动大规模物联网部署，进一步带来更经济、更高效分发、更简化的SIM周期管理过程等优势的连接方案。",
    p23: "RedteaSIM - 新型SIM分发管理方案",
    p24: "了解更多红茶移动“连接即服务”的产品与解决方案，请访问：",
    p25: "#台湾eSIM应用 #RedteaCaaS #智能制造  #智能IoT #低功耗广域物联网",
    p26: "从「智能制造」过渡到「智能IoT」，连接是关键",
  },
  article18: {
    title: "红茶移动针对苹果手机推出基于eSIM的数据网络服务RedteaGO",
    p1: "(RedteaGO Global eSIM Plan)",
    p2: "【深圳，2020年2月25日】领先的设备连接解决方案提供商红茶移动 (Redtea Mobile) 近日推出针对新iPhone系列的eSIM网络服务RedteaGO。 iPhone 11、iPhone 11 Pro、iPhone 11 Pro Max、iPhone XS、iPhone XR机型用户可以直接通过手机添加激活蜂窝网络套餐，从而轻松实现在同一台手机设备上享用两套独立的数据流量服务。",
    p3: "(iphone双卡槽）",
    p4: "该服务推出后，以上iPhone机型（海外无锁版）用户只需从苹果应用商店下载RedteaGO App，并将系统升级至iOS 13.3或更高版本，即可在全球超过50个国家及地区的旅游和商务出行中自由享受灵活便捷、资费优廉的数据上网服务。RedteaGO服务预计将在近期新增更多目的地国家覆盖。",
    p5: "(针对iPhone eSIM的RedteaGO App)",
    p6: "RedteaGO为iPhone用户提供全球蜂窝网络连接服务，用户可以基于手机设备所在的位置远程获取当地网络流量，无需实体SIM卡。",
    p7: "红茶移动联合创始人兼CEO金辉博士表示：“RedteaGO让iPhone用户实现了在全球多个国家和地区动态选择移动网络服务的自由，流量套餐可以即买即用，非常便利。作为iPhone用户明智而无忧的选择，RedteaGO真正具备震撼行业，并在社区中产生深远影响的潜力。”",
    p8: "(针对iPhone eSIM的RedteaGO App)",
    p9: "(带上RedteaGO去旅行，全球流量不用愁)",
    p10: "了解更多信息请前往",
    p11: "关于红茶移动",
    p12: "红茶移动是富有开创精神的eSIM技术实践者及设备连接方案服务提供商，专注于为全球多样化的移动设备提供覆盖广泛的蜂窝网络连接服务及一站式eSIM解决方案。我们提供全球超过100个国家及地区的2G/3G/4G网络覆盖，eSIM连接能力已触达超过2.5亿终端。访问",
    p13: "了解更多。",
    p14: "了解更多详情:",
    p15: "",
    p151: "",
    p16: "",
    p161: "",
    p17: "",
    p171: "",
    p18: "",
    p181: "",
    p19: "",
    p191: "",
    p20: "红茶移动知乎：",
    p201: "红茶移动推出RedteaGO App：目前中国唯一一家苹果官网全球eSIM服务商",
    p21: "RedteaGO eSIM全家桶：支持的手机机型详解篇",
    p22: "国内媒体报道：",
    p23: "央广网：",
    p231: "http://news.cnr.cn/native/lmgd/20200226/t20200226_524992205.shtml",
    p24: "网易新闻",
    p241: "http://news.163.com/20/0226/11/F6AEINTL000189DG.html",
    p25: "凤凰网",
    p251: "https://tech.ifeng.com/c/7uLfMZ7hbGm",
  },
  eSimPlus: {
    t1: "End-to-End eSIM Solution Enabler for mobile operators",
    t2: `To enable highly-efficient communication between operators and OEMs(both consumer devices and IoT devices) based on eSIM remote provisioning and to offer a full set of eSIM service for mobile operators to go digital.`,
    t3: "eSIM.plus enable operators to capture eSIM users in a fast and secure way",
    t4: "With constantly growing kinds of eSIM devices reaching up to 110 models at the end of 2020, across smartphones, smartwatches, laptops, tablets as well as IoT devices, mobile operators around the world are looking to capture new eSIM users and onboard new eSIM devices.",
    t5: `eSIM.plus offers an end-to-end eSIM enablement solution for operators, to enable operators to go digital and to deliver completely new eSIM devices onboarding experience for both consumer and M2M devices.`,
    t6: `a full set of eSIM service or service offering of its components
    like SM-DP+ (remote SIM provisioning platform, cloud-based or in
    house SM-DP+ deployment ), Terminal Service Entitlement (TSE)
    (entitlement server), Carrier App development for both Android and
    iOS devices. `,
    t7: `Abstract away the complexity of communication between
    mobile operators and OEMs to deliver eSIM profiles in a secure and
    efficient way.`,
    t8: `innovative user experience by allowing authorised
    subscribers to use mobile services with entitlement features
    available on devices including smartwatches,
    laptop, etc.`,
    t9: `GSMA SAS-SM accredited site in Europe for eSIM provisioning`,
    t10: "To embrace a promising eSIM market",
    t11: `Customer demand for eSIM is on the rise. New devices with eSIM
    technology are launching very frequently including low budget
    handsets. As per Counterpoint report, by 2025, eSIM devices will
    reach up to 6 billion, with eSIM smartphones shipment taking up 45%
    which is approximately 2.5 billion and increases in eSIM shipments
    driven by the launch of new eSIM IoT devices as well.`,
    t12: `And according to the report by GSMA intelligence, commercial eSIM
    service for smartphones had been launched in at least 69 countries
    by the end of 2020, – a threefold increase compared to in 2018. eSIM
    service is commercially available for more than 2 billion mobile
    users.`,
    t13: "Challenges",
    t14: "Onboarding OEMs is complex.",
    t15: "Traditional business model requires transition for innovative experience for revenue growth.",
    t16: `Managing eSIM lifecycle for IoT devices deployed globally is tedious task because of different OS, modules, chipsets, and network parameters.`,
    t17: `Providing connectivity and multiple roaming agreements with different operators causes delay in deployment and are very costly.`,
    t18: `Opportunities for telcos`,
    t19: "Fast GTM Process",
    t20: "End-to-end eSIM solution from connection to management, enabling convenient and instant customer registration.",
    t21: "New Revenue Stream",
    t22: "Connectivity services to additional devices like smartwatches, laptops, IoT, etc., for operator to generate more revenue as additional sales channel.",
    t23: "Cost Savings",
    t24: "No more traditional SIM lifecycle, to connect millions of devices efficiently based on convenient eSIM activation.",
    t25: "Customer Acquisition",
    t26: "Remote configuration of mobile devices to activate eSIM and eSIM transfer made easy to reduce user churn, to gain more users previously bound to one carrier.",
    t27: "eSIM.plus enables operators to onboard eSIM device easily",
    t28: "Enable",
    t29: "Programmable",
    t30: "Scalable",
    t31: `Authorized eSIM API to onboard eSIM devices,  in an easy flow.`,
    t32: `To configure primary and secondary devices, with one eSIM profile automatically.`,
    t33: `Existing APP or SDK to start eSIM service quickly with users.`,
    t34: `Cloud-based or in-house deployment of SM-DP+, quick integration with operator BSS/OSS, within one week.`,
    t35: `To configure a series of ES features, offering OTA download of eSIM profiles, eSIM transfer, simply with eSIM SDK.`,
    t36: `Digital eSIM subscription experience, to connect global eSIM devices, anytime, anywhere, in an instant.`,
    t37: `Expert team for end-to-end solution design consultancy, as a whole.`,
    t38: `To manage eSIM devices, eSIM subscription and user notification, all in the cloud.`,
    t39: `Compatible with both consumer and IoT devices, to unlock massive IoT market.`,
    t40: `Unlock new revenue stream and new business models`,
    t41: `To enable Multi-device connection based on eSIM`,
    t42: `To onboard consumer eSIM devices with ES features (both Android and iOS, compliant with Apple, Samsung, Huawei etc)`,
    t43: `To connect a breed of M2M devices (Vehicle、POS machine、PC、video camera、T-box、CPE etc)`,
    t44: `To develop built-in mobile carrier APP for easy eSIM user experience, without visiting physical store`,
    t45_1: `The telco-level RSP for eSIM remote provisioning with SAS-SM certified high-security IDC`,
    t45_2: `eSIM.plus Entitlement Server - bridging mobile operators and terminals for authorized entitlement service`,
    t45_3: `Carrier APP - eSIM App for operators to onboard eSIM users, simply with a few clicks`,
    t46: `Following a technical specification that enables "over the air" installation and management of operator profiles as prescribed by The GSMA eUICC standard, eSIM.plus RSP hosts eSIM profiles covering more than 100 countries and offers eSIM provisioning and management for mobile operators with reliable telco-level service: `,
    t47: `Deployed on the SAS-SM certified high-security IDC in Amsterdam and GSMA certified;`,
    t48: `Enabled remote provisioning, eSIM profile download with profile lifecycle management;`,
    t49: `Easy integration with operator BSS via ES2+ interface to generate AC Codes or QR codes; `,
    t50: `The telecommunication industry-level security with 99.95% reliability.`,
    t50_1: "SAS-SM Certification by GSMA",
    t50_2: "Fast integration with BSS/OSS",
    t50_3: "Telco-level reliability",
    t50_4: "Cloud-based or in-house deployment",
    t51_1: `With the growth of eSIM devices, reaching up to 60 billion with 50% eSIM consumer devices and 50% M2M devices, driven by main smartphone OEMs like Apple, Samsung and Huawei etc, operators are likely to gain a new breed of device connections for new revenue stream, having an entitlement server is a mandatory requirement from those device to connect to operator.`,
    t51_2: `With eSIM.plus entitlement server, operators will find it much easier to expand their businesses into emerging eSIM markets across both consumer and M2M devices including automotive, wearables and consumer electronics.`,
    t52_1: `eSIM.plus Entitlement Server offers:`,
    t52_2: `>> both cloud-based deployment with API or in-house deployment
    to work across
    <span>any device or operating system</span> that supports
    entitlement server.`,
    t52_3: `>> eSIM-based multi-device services and all ES released
    features (in compliance with
    <span>Apple, Samsung and Huawei</span> etc);`,
    t52_4: `>> <span> a full set of entitlement services</span> with
    functions like device authentication and remote provisioning,
    eSIM profile download, eSIM transfer, VoWifi etc.`,
    t52_5: `>> quick websheet integration which provides necessary details
    to the end user about the mobile operator’s subscriptions and
    settings.`,
    t52_6: `eSIM.plus Entitlement Server takes care of all the complexity,
    simply with our eSIM API.`,
    t53_1: `Fast integration within 1 week`,
    t53_2: `Simple eSIM API`,
    t53_3: `7*24 hour support`,
    t53_4: `both consumer and M2M`,
    t54: `eSIM.plus Carrier app is the mobile app technology which uses
    device LPA interface and integrated with operators’ back-end
    system, providing smooth and enhanced user experience for eSIM
    service activation and bundle. Carrier App requires ES2+
    integration (Operators’ back end and SM-DP+).`,
    t55: `eSIM.plus also provide mobile APP for inbound and outbound
    travelers，either in the format of APP or SDK to integrate with
    existing Application by mobile operators.`,
    t55_1: `Official Apple eSIM partner to serve global iPhones and iPads.`,
    t55_2: `10+ cellphone OEM partners for both Android and iOS.`,
    t55_3: `Full digital experience without visiting point of sales.`,
    t55_4: `Faster GTM to onboard users with existing APP or SDK. `,
    t69: `Customers and Partners`,
    t70: `Sales Inquiry`,
    t71: `For consultancy to onboard millions of eSIM devices for your next project`,
    t72: `Our expert for consultancy on your next IoT project based on
    eSIM deployment for the next millions of device management. Our
    business solutions featured here are tailored for telcos to connect
    a new breed of mobile devices, especially`,
    t73: `eSIM devices up to 6 billion by 2025.`,
    t72: `NAME`,
    t73: `WORK E-MAIL`,
    t74: `COUNTRY/REGION`,
    t75: `INDUSTRY`,
    t76: `COMPANY`,
    t77: `YOUR MESSAGE`,
    t78: `Write a few words about your business`,
    t79: `Sales Inquiry`,
  },
  eSimPlusMobile: {
    p1: "End-to-End eSIM Solution Enabler for mobile operators",
    p2: "To enable highly-efficient communication between operators and OEMs(both consumer devices and IoT devices) based on eSIM remote provisioning and to offer a full set of eSIM service for mobile operators to go digital.",
    p3: "SM-DP+",
    p4: "Terminal Entitlement Server",
    p5: "Carrier APP",
    p6: "Download the PDF",
    p7: "End-to-End eSIM Solution Enabler for mobile operators",
    p8: "With constantly growing kinds of eSIM devices reaching up to 110 models at the end of 2020, across smartphones, smartwatches, laptops, tablets as well as IoT devices, mobile operators around the world are looking to capture new eSIM users and onboard new eSIM devices.",
    p9: "eSIM.plus offers an end-to-end eSIM enablement solution for operators, to enable operators to go digital and to deliver completely new eSIM devices onboarding experience for both consumer and M2M devices.",
    p10: "a full set of eSIM service or service offering of its components like SM-DP+ (remote SIM provisioning platform, cloud-based or in house SM-DP+ deployment ), Terminal Service Entitlement (TSE) (entitlement server), Carrier App development for both.",
    p11: "Android and iOS devices. <br/>Abstract away the complexity of communication between mobile operators and OEMs to deliver eSIM profiles in a secure and efficient way.",
    p12: "innovative user experience by allowing authorised subscribers to use mobile services with entitlement features available on both iOS and Android devices including smartwatches, laptop, etc.",
    p13: "GSMA Certified SAS-SM accredited site for eSIM provisioning",
    p14: "To embrace a promising eSIM market",
    p15: "Customer demand for eSIM is on the rise. New devices with eSIM technology are launching very frequently including low budget handsets. As per <a href=''>Counterpoint</a> report, by 2025, eSIM devices will reach up to 6 billion, with eSIM smartphones shipment taking up 45% which is approximately 2.5 billion and increases in eSIM shipments driven by the launch of new eSIM IoT devices as well.",
    p16: "And according to the report by GSMA intelligence, commercial eSIM service for smartphones had been launched in at least 69 countries by the end of 2020, – a threefold increase compared to in 2018. eSIM service is commercially available for more than 2 billion mobile users.",
    p17: "Challenges",
    p18: "Onboarding OEMs is complex.",
    p19: "Traditional business model requires transition for innovative experience for revenue growth.",
    p20: "Managing eSIM lifecycle for IoT devices deployed globally is tedious task because of different OS, modules, chipsets, and network parameters.",
    p21: "Providing connectivity and multiple roaming agreements with different operators causes delay in deployment and are very costly.",
    p22: "Opportunities for telcos",
    p23: "Fast GTM Process:",
    p24: "End-to-end eSIM solution from connection to management, enabling convenient and instant customer registration.",
    p25: "New Revenue Stream:",
    p26: "Connectivity services to additional devices like smartwatches, laptops, IoT, etc., for operator to generate more revenue as additional sales channel.",
    p27: "Cost Savings:",
    p28: "No more traditional SIM lifecycle, to connect millions of devices efficiently based on convenient eSIM activation.",
    p29: "Customer Acquisition:",
    p30: "Remote configuration of mobile devices to activate eSIM and eSIM transfer made easy to reduce user churn, to gain more users previously bound to one carrier.",
    p31: "eSIM.plus enables operators to onboard eSIM device easily",
    p32: "Enable",
    p33: "Authorized eSIM API to onboard eSIM devices,  in an easy flow.",
    p34: "Cloud-based or in-house deployment of SM-DP+, quick integration with operator network backend(BSS), within one week.",
    p35: "Expert team for end-to-end solution design consultancy, as a whole.",
    p36: "Programmable",
    p37: "To configure primary and secondary devices, with one eSIM profile automatically",
    p38: "To configure a series of ES features, offering OTA download of eSIM profiles, eSIM transfer, simply with eSIM SDK.",
    p39: "To manage eSIM devices, eSIM subscription and user notification,  all in the cloud.",
    p40: "Scalable",
    p41: "Existing APP or SDK to start eSIM service quickly with users.",
    p42: "Digital eSIM subscription experience, to connect global eSIM devices, anytime, anywhere, in an instant.",
    p43: "Compatible with both consumer and IoT devices, to unlock massive IoT market.",
    p44: "Unlock new revenue stream and new business models",
    p45: "To enable Multi-device connection based on eSIM",
    p46: "To onboard consumer eSIM devices with ES features (both Android and iOS,  compliant with Apple, Samsung, Huawei etc)",
    p47: "To connect a breed of M2M devices (vehicle POS machine、PC、video camera、T-box、CPE etc",
    p48: "To develop built-in mobile carrier APP for easy eSIM user experience, without visiting physical store",
    p49: "An end-to-end eSIM enabler solution for mobile operators",
    p50: 'Following a technical specification that enables "over the air" installation and management of operator profiles as prescribed by The GSMA eUICC standard, eSIM.plus RSP hosts eSIM profiles covering more than 100 countries and offers eSIM provisioning and management for mobile operators with reliable telco-level service:',
    p51: "Deployed on the SAS-SM certified high-security IDC in Amsterdam and GSMA certified;",
    p52: "Enabled remote provisioning, eSIM profile download with profile life cycle management;",
    p53: "Easy integration with operator BSS via ES2+ interface to generate AC Codes or QR codes; ",
    p54: "The telecommunication industry-level security with 99.95% reliability.",
    p55: "GSMA",
    p56: "Fast integration",
    p57: "Telco-level reliability",
    p58: "Cloud-based",
    p59: "eSIM.plus Entitlement Server - bridging mobile operators and terminals for authorized entitlement service",
    p60: "Featuring eSIM provisioning for primary and secondary devices, eSIM.plus entitlement server enables operators to authenticate and provision eSIM profiles on companion devices ( both consumer devices and IoT devices ).",
    p61: "eSIM.plus Entitlement Server offers:",
    p62: ">> both cloud-based deployment with API or in-house deployment to work across <span class='bold'>any device or operating system</span>  that supports entitlement server.",
    p63: ">> eSIM-based multi-device services and all ES released features (in compliance with <span class='bold'>Apple, Sumsang and Huawei</span> etc);",
    p64: ">> <span class='bold'>a full set of entitlement services</span> with functions like device authentication and remote provisioning, eSIM profile download etc.",
    p65: "eSIM.plus Entitlement Server takes care of all the complexity, simply with our eSIM API",
    p66: "Fast integration within one week",
    p67: "Simple eSIM API",
    p68: "7*24 hour support",
    p69: "Enable both consumer and M2M",
    p70: "Carrier APP - eSIM App for operators to onboard eSIM users, simply with a few clicks",
    p71: "eSIM.plus Carrier app is the mobile app technology which uses device LPA interface and integrated with operators’ back-end system, provides smooth and enhanced user experience for eSIM service activation and bundle. Carrier App requires ES2+ integration (Operators’ back end and SM-DP+).”",
    p72: "eSIM.plus also provde mobile APP for inbound and outbound travelers either in the format of APP or SDK to integrate with existing Application by mobile operators.",
    p73: "Official Apple eSIM partner to serve global users of all eSIM iPhones and iPads.",
    p74: "10+ cellphone OEM partners for both Android and iOS.",
    p75: "Full digital experience without visiting point of sales.",
    p76: "Faster GTM to onboard users with existing APP or SDK.",
    p77: "Comprehensive eSIM ecosystem for truly eSIM-as-a-service",
    p78: "Sales Contact",
    p79: "DISCUSS YOUR POTENTIAL WITH ESIM",
    p80: "Talk to our expert for consultancy on your next IoT project based on eSIM deployment for the next millions of device management.",
    p81: "Our business solutions featured here are tailored for telcos to connect a new breed of mobile devices, especially ",
    p82: "eSIM devices up to 6 billion by 2025.",
    p83: `YOUR NAME`,
    p84: `YOURE-MAIL`,
    p85: `COUNTRY`,
    p86: `INDUSTRY`,
    p87: `COMPANY`,
    p88: `YOUR MESSAGE`,
    p89: `Write a few words about your business`,
    p90: `Talk to our expert`,
  },
  i: {
    select: {
      noMatch: "No match",
      loading: "Loading",
    },
  },
};